<template>
    <div v-if="show" class="popup-container" :class="[{ blocking: blocking }, customClass, $mq, mood, { 'email-alert': type === 'emailAlert' }, { tablePopup: type === 'tableColumn' }, { renew: type === 'renew' }, { 'item-settings': type === 'itemSettings' }]" @click.self="onContainerClick">
        <div class="popup" v-bind:class="[type, { editing: type === 'plsReset' && plsResetEditing }]">
            <!-- bind class popup.clases AND TYPE -->
            <div class="pop-alex" :class="[{ error: showingError }, mood]" v-if="!disabledAlexIcon.includes(type)"></div>
            <div v-if="type == 'select' || type == 'phuProduct' || type == 'phuAssign' || type == 'phuNoEquipment'" class="pop-alex-lottie">
                <LottieAnimation v-if="type == 'select' || type == 'phuProduct' || type == 'phuAssign' || type == 'phuNoEquipment'" :timeToRepeat="10000" :loopAnimation="true" :animationName="'andy.json'"></LottieAnimation>
            </div>

            <!-- <div class="pop-header" v-if="type != 'media' && type != 'library'" >
                <p v-if="title" class="title-message">{{title}}</p>
             </div> -->

            <div class="pop-header" v-if="type === 'action-plan-loss' || type === 'action-plan-create' || type === 'simple-confirm'">
                <p v-if="title" class="title">{{ title }}</p>
            </div>

            <div class="pop-header" v-if="type === 'printConfig'">
                <div class="title">
                    <i class="i-andy-menu-config i-andy-m"></i>
                    <p>{{ title }}</p>
                </div>
                <i class="i-andy-close i-andy-m" @click="cancel('cross')"></i>
            </div>

            <div class="pop-header" v-if="type === 'plsAddProduct'">
                <div class="title">
                    <p>{{ title }}</p>
                </div>
                <i class="i-andy-close i-andy-m" @click="cancel('cross')"></i>
            </div>

            <div class="pop-header" v-if="type === 'plsReset' || type === 'plsResetConfirm'">
                <div class="title">
                    <p>{{ title }}</p>
                </div>
                <i class="i-andy-close i-andy-m" @click="cancel('cross')"></i>
            </div>

            <div class="pop-header" v-if="type === 'plsResetLoading'">
                <div class="title">
                    <i class="i-andy-chart-bar i-andy-m" aria-hidden="true"></i>
                    <p>{{ title }}</p>
                </div>
            </div>

            <div class="pop-header" v-if="type === 'messageNewDesing'">
                <div class="title">
                    <p>{{ title }}</p>
                </div>
                <i class="i-andy-close i-andy-m" @click="cancel('cross')"></i>
            </div>

            <div class="pop-header" v-if="type === 'numericNewDesing'">
                <div class="title">
                    <p>{{ title }}</p>
                </div>
                <i class="i-andy-close i-andy-m" @click="cancel('cross')"></i>
            </div>

            <div class="pop-header" v-if="type === 'phuWaste'">
                <p class="phu-waste__title">{{ title }}</p>
                <button type="button" class="phu-waste__close" :aria-label="textCancel" @click="cancel('cross')">
                    <i class="i-andy-close i-andy-m" aria-hidden="true"></i>
                </button>
            </div>

            <div class="pop-header" v-if="type === 'issueAlert'">
                <div class="title">
                    <p>{{ title }}</p>
                </div>
                <i class="i-andy-close i-andy-m" @click="cancel('cross')"></i>
            </div>

            <div class="pop-header landscape-text-header" v-if="type === 'textInputLandscape' && title">
                <p class="title">{{ title }}</p>
            </div>

            <div class="pop-body">
                <!-- media -->
                <div class="kind-of preview hide-scrollbar" v-if="type == 'media' || type == 'previewSignature'">
                    <div v-if="image">
                        <img v-if="typeof image === 'string'" :src="image" class="preview-media-img" />
                        <img v-else v-for="(img, key) in image" :src="img" :key="key" class="preview-media-img" />
                    </div>
                    <p v-else class="empty"></p>
                    <p v-if="type == 'media' && caption" class="popup-media-caption">{{ caption }}</p>
                </div>

                <!-- tableColumn -->
                <h1 v-if="type == 'tableColumn'">{{ title }}</h1>
                <p v-show="showingError && type !== 'issueAlert'" class="message-error" v-html="messageError"></p>
                <div class="kind-of check-container" v-if="type == 'tableColumn'">
                    <!-- <div v-if="header.text != ''" v-for="(header, index) in $data.headers" @click="checkHeader(header)" :class="{ activeHeader: header.visible === true }" :key="index" class="check-box">
                        <div class="check-input"></div>
                        <p class="check-title">{{ header.text }}</p>
                    </div> -->
                    <draggable v-model="columnHeaders" handle=".table-column-drag-handle" @start="drag = true" @end="drag = false">
                        <div v-if="header.text != ''" v-for="header in columnHeaders" :key="header.value" @click="checkHeader(header)" class="check-box-container">
                            <div class="table-column-drag-handle" aria-hidden="true" @click.stop></div>
                            <div :class="{ activeHeader: header.visible === true }" class="check-box">
                                <div class="check-input"></div>
                                <p class="check-title">{{ header.text }}</p>
                            </div>
                        </div>
                    </draggable>
                </div>

                <!-- Select, -->
                <div class="kind-of" v-else-if="type == 'select'">
                    <p v-show="showingError" class="message-error" v-html="messageError"></p>
                    <SearchBar :search="search" @on-search="searchBarInput" @on-button-click="cleanSearch" :placeholder="getString('popup.audits.search_placeholder')" />
                    <ul v-if="Object.keys(list).length > 0" class="list select-list">
                        <li v-for="(item, key) in filteredList" :key="key" :class="{ item: true, default: item.default, selected: selectedEl === item.id }" :data-id="item.id" @click="selectMe(item.id, key)">
                            <span class="name" v-if="item.name">{{ item.name }}</span>
                        </li>
                    </ul>
                    <p v-else class="empty" v-html="title"></p>
                </div>

                <!-- Select double -->
                <div class="kind-of" v-else-if="type == 'selectDouble'">
                    <p v-show="showingError" class="message-error" v-html="messageError"></p>

                    <div class="left hide-scrollbar">
                        <ul v-if="Object.keys(list).length > 0" class="list users-list hide-scrollbar">
                            <li v-for="item in list" class="item user" :class="{ selected: selectedEl == item.id }" @click="selectMe(item.id)">
                                <span class="user-color"><img class="main-img" v-bind:src="item.avatar" /> "></span>
                                <span class="user-name">{{ item.name }} {{ item.surname }}</span>
                            </li>
                        </ul>
                        <p v-if="Object.keys(list).length == 0" class="empty" v-html="listEmpty"></p>
                    </div>

                    <div class="right hide-scrollbar" :class="{ disabled: selectedEl == undefined }">
                        <ul v-if="Object.keys(listSec).length > 0" class="list select-list hide-scrollbar" :data-msg="disabledMessage">
                            <li v-for="item in listSec" v-if="item.default" class="item default" :class="[{ selected: selectedSecEl == item.id }]" :id="item.id" @click="selectMeSec(item.id)">
                                <span class="name">{{ item.name }}</span>
                            </li>
                            <li v-for="item in listSec" v-if="!item.default" class="item" :class="[{ selected: selectedSecEl == item.id }]" :id="item.id" @click="selectMeSec(item.id)">
                                <span class="name">{{ item.name }}</span>
                            </li>
                        </ul>
                        <p v-if="Object.keys(listSec).length == 0" class="empty" v-html="listEmpty"></p>
                    </div>
                </div>

                <!-- numeric -->
                <Numpad class="kind-of" v-else-if="type == 'numeric'" :sensorType="tempOptions.sensorType" @sendValue="changeValue" @saveAndClose="save" :givenValue="inputVal" :decimal="decimal" :hasNegative="hasNegative" :pinType="'numeric'" @updateSensorStep="tempUpdateSensorStep"></Numpad>

                <!-- newnumeric -->
                <div class="kind-of" v-else-if="type == 'numericNewDesing'">
                    <div class="content">
                        <div class="product-info" v-if="productName && productUrl">
                            <img :src="productUrl" alt="product-image" />
                            <p>{{ productName }}</p>
                        </div>
                        <p v-if="productMessage" class="product-message">{{ productMessage }}</p>
                        <Numpad @sendValue="changeValue" @saveAndClose="save" :sensorType="tempOptions.sensorType" :givenValue="inputVal" :decimal="decimal" :hasNegative="hasNegative" :pinType="'numeric'" :newDesing="true" :quantity="true" :max="numericNewDesing.max" :min="1" :preventMobileKeyboard="true"></Numpad>

                        <div class="footer" v-if="customClass.toString().includes('pls-stock-popup')">
                            <p class="remove-recommendation" @click="callDelete">Eliminar recomendación</p>
                        </div>
                    </div>
                </div>

                <!-- Message New Desing -->
                <div class="kind-of" v-else-if="type == 'messageNewDesing'">
                    <div class="content">
                        <p>{{ message }}</p>
                    </div>
                </div>

                <!-- temperature -->
                <PopupTemperature class="hide-scrollbar" v-else-if="type == 'temperature'" @sendValue="changeValue" @saveAndClose="save" :givenValue="inputVal" :stepNum="tempOptions.stepNum" :numDec="tempOptions.numDec" :stepDec="tempOptions.stepDec" :mesure="tempOptions.mesure" :sensorType="tempOptions.sensorType" :hasNegative="true" @updateSensorStep="tempUpdateSensorStep"></PopupTemperature>

                <!-- Ticket -->
                <PopupTicket class="kind-of" v-else-if="type == 'ticket'" @sendValue="changeValue" @saveAndClose="save" ref="popupTicket"></PopupTicket>

                <!-- DateTime -->
                <PopupDateTime class="kind-of" v-else-if="type == 'dateTime'" :showingError="showingError" :messageError="messageError" :date="date" :time="time" :only_past="only_past" @sendValue="changeValue" @saveAndClose="save" ref="dateTime"> </PopupDateTime>

                <!-- Geolocation -->
                <PopupGeolocation v-else-if="type == 'geolocation'" class="geolocation" ref="popupGeolocation"> </PopupGeolocation>

                <!-- Resource -->
                <PopupResource v-else-if="type == 'resource'" class="resource" :resource="resource" ref="popupResource" @close="cancel('cross')"> </PopupResource>

                <!-- quantity -->
                <div class="kind-of" v-else-if="type == 'quantity'">
                    <div class="left hide-scrollbar">
                        <p class="message">{{ message }}</p>
                        <h6>{{ productName }}</h6>

                        <!-- <button v-if="inputVal > 0" class="act rem-amount" @click="removeAll">
                      {{ getString('popup.quantity.remove_all') }}
                    </button> -->
                    </div>

                    <div class="right hide-scrollbar">
                        <Numpad @sendValue="changeValue" :decimal="decimal" :givenValue="inputVal" :max="100"></Numpad>
                    </div>
                </div>

                <!-- timeClock -->
                <div class="kind-of" v-else-if="type == 'timeclock'">
                    <div class="left hide-scrollbar">
                        <div class="place">
                            <div class="item" :class="selectedTab == 'all' ? 'selected' : ''" @click="selectTab('all')" data-val="all">Todos</div>
                            <div class="item" :class="selectedTab == 'in' ? 'selected' : ''" @click="selectTab('in')" data-val="in">En Local</div>
                            <div class="item" :class="selectedTab == 'out' ? 'selected' : ''" @click="selectTab('out')" data-val="out">Fuera</div>
                        </div>
                        <p v-show="showingError" class="message-error" v-html="messageError"></p>

                        <ul v-if="Object.keys(list).length > 0" class="list users-list hide-scrollbar">
                            <li v-for="item in list" class="item user" :class="[item.clockClass ? item.clockClass : '', selectedEl == item.id ? 'selected' : '']" v-bind:data-id="item.id" v-if="selectedTab == 'all' || (item.clockClass == 'clocked-in' && selectedTab == 'in') || (item.clockClass == 'clocked-out' && selectedTab == 'out')" @click="selectMe(item.id)">
                                <span class="user-color"><img class="main-img" v-bind:src="item.avatar" /></span>
                                <span class="user-name">{{ item.name }} {{ list.surname }}</span>
                            </li>
                        </ul>
                        <p v-if="Object.keys(list).length == 0" class="empty" v-html="listEmpty"></p>
                    </div>

                    <div class="right hide-scrollbar" :class="{ disabled: selectedEl == undefined }">
                        <Numpad @sendValue="changeValue" :pinType="'password'" :givenValue="inputVal" :disabled="disNumpad"></Numpad>
                    </div>
                </div>

                <!-- login, access -->
                <div class="kind-of" v-else-if="type == 'login'">
                    <template v-if="Object.keys(list).length > 0">
                        <p class="disabledMessage">{{ loginDisabledMessage }}</p>
                        <p v-show="message" class="message-info" v-html="message"></p>
                        <div class="mainContainer">
                            <div class="left">
                                <p v-show="showingError" class="message-error" v-html="messageError"></p>

                                <ul v-if="Object.keys(list).length > 0" class="list users-list hide-scrollbar">
                                    <li v-for="item in list" class="item user" :class="{ selected: selectedEl == item.id }" v-bind:data-id="item.id" @click="selectMe(item.id)">
                                        <span class="user-color"><img class="main-img" v-bind:src="item.avatar" /></span>
                                        <span class="user-name">{{ item.name }} {{ item.surname }}</span>
                                    </li>
                                </ul>
                                <p v-if="Object.keys(list).length == 0" class="empty" v-html="listEmpty"></p>
                            </div>

                            <div class="right hide-scrollbar" :class="{ disabled: selectedEl == undefined }">
                                <Numpad @sendValue="changeValue" v-bind:pinType="'password'" v-bind:givenValue="inputVal" v-bind:disabled="disNumpad"></Numpad>
                            </div>
                        </div>
                    </template>

                    <template v-else>
                        <p class="message">{{ getString('tooltip.error_logout') }}</p>
                    </template>
                </div>
                <div class="kind-of" v-else-if="type == 'access'">
                    <template v-if="Object.keys(list).length > 0">
                        <div class="left hide-scrollbar">
                            <p v-show="message" class="message-info" v-html="message"></p>
                            <p v-show="showingError" class="message-error" v-html="messageError"></p>

                            <ul v-if="Object.keys(list).length > 0" class="list users-list hide-scrollbar">
                                <li v-for="item in list" class="item user" :class="{ selected: selectedEl == item.id }" v-bind:data-id="item.id" @click="selectMe(item.id)">
                                    <span class="user-color"><img class="main-img" v-bind:src="item.avatar" /></span>
                                    <span class="user-name">{{ item.name }} {{ item.surname }}</span>
                                </li>
                            </ul>
                            <p v-if="Object.keys(list).length == 0" class="empty" v-html="listEmpty"></p>
                        </div>

                        <div class="right hide-scrollbar" :class="{ disabled: selectedEl == undefined }">
                            <Numpad @sendValue="changeValue" v-bind:pinType="'password'" v-bind:givenValue="inputVal" v-bind:disabled="disNumpad"></Numpad>
                        </div>
                    </template>

                    <template v-else>
                        <p class="message">{{ getString('tooltip.error_logout') }}</p>
                    </template>
                </div>

                <!-- Print Config -->
                <div class="kind-of" v-else-if="type == 'printConfig'">
                    <div class="content">
                        <div class="option" :class="{ selected: selected === item.id }" @click="selected = item.id" v-for="item in options" :key="item.id">
                            <span class="ball"></span>
                            <p>{{ item.text }}</p>
                        </div>
                    </div>
                </div>

                <!-- Detalle de libreria -->
                <LibraryDetail class="kind-of" v-else-if="type == 'library'" :file="file"></LibraryDetail>

                <!-- Seleccionable fecha -->
                <div class="kind-of" v-else-if="type == 'date'">
                    <!-- :allowed-dates="allowedDates" -->

                    <functional-calendar v-model="inputVal" :dayNames="getStringObject('calendar.day_names')" :monthNames="getStringObject('calendar.months')" :shortMonthNames="getStringObject('calendar.months')" :isDatePicker="true" :change-month-function="true" :date-format="'yyyy/mm/dd'" :change-year-function="true" :limits="{ min: '', max: '' }"></functional-calendar>
                    <!-- <v-date-picker
                        v-model="inputVal"
                        :locale="aLocale"
                        landscape
                        reactive
                        :min="dateStart"
                        :max="dateEnd"
                        first-day-of-week="1"
                    ></v-date-picker> -->
                </div>

                <!-- Seleccionable fecha RANGO -->
                <div class="kind-of hide-scrollbar" v-else-if="type == 'dateRange'">
                    <!-- :allowed-dates="allowedDates" -->

                    <!-- :is-multiple="true"
                                    :calendars-count="2" -->
                    <functional-calendar v-model="dateRange" :dayNames="getStringObject('calendar.day_names')" :monthNames="getStringObject('calendar.months')" :shortMonthNames="getStringObject('calendar.months')" :isDatePicker="true" :key="updatedDayCalendarTwo" @input="dayClickedCalendarOne" :change-month-function="true" :date-format="'yyyy/mm/dd'" :change-year-function="true" :limits="{ min: '', max: dateRangeTwo.selectedDate ? dateRangeTwo.selectedDate : dateEnd }"></functional-calendar>
                    <!-- :limits="{min: '', max: dateRangeTwo.selectedDate ? dateRangeTwo.selectedDate : dateEnd}" -->

                    <!-- <v-date-picker
                        v-model="dateRange[0]"
                        :locale="aLocale"
                        reactive
                        :min="dateStart"
                        :max="dateEnd"
                        first-day-of-week="1"
                    ></v-date-picker> -->

                    <functional-calendar :key="updatedDayCalendarOne" v-model="dateRangeTwo" :dayNames="getStringObject('calendar.day_names')" :monthNames="getStringObject('calendar.months')" :shortMonthNames="getStringObject('calendar.months')" :isDatePicker="true" :change-month-function="true" :change-year-function="true" :date-format="'yyyy/mm/dd'" :limits="{ min: dateRangeFirstCalendar.selectedDate ? dateRangeFirstCalendar.selectedDate : '', max: dateEnd }"></functional-calendar>
                    <!-- @input="dayClickedCalendarTwo" -->

                    <!-- <v-date-picker
                        v-model="dateRange[1]"
                        :locale="aLocale"
                        reactive
                        :min="dateRange[0]"
                        :max="dateEnd"
                        first-day-of-week="1"
                    ></v-date-picker> -->

                    <!-- <div class="fcalendar-container">
                  <functional-calendar
                    v-model="dateRange[0]"
                    @input="setRangeResult(dateRange[0])"
                    :is-multiple="true"
                    :is-date-range="true"
                    :calendars-count="2"
                    :isDatePicker="true"
                    :change-month-function="true"
                    :change-year-function="true"
                    :markedDates="[{date: dateEnd, class: 'expiration'},{date: dateRange[0], class: 'vfc-marked'}]"
                    :limits="{min: dateStart, max: ''}"
                  ></functional-calendar>
                </div> -->
                </div>

                <!-- Text input landscape -->
                <div class="kind-of text-input-landscape" v-else-if="type === 'textInputLandscape'">
                    <form class="landscape-text-form" @submit.prevent="submitLandscapeText(true)">
                        <textarea
                            v-if="multiline"
                            ref="landscapeTextInput"
                            v-model="inputVal"
                            :maxlength="maxlength"
                            dir="ltr"
                            enterkeyhint="done"
                            class="landscape-text-input input-text-ltr"
                            @input="onLandscapeTextInput"
                            @blur="onLandscapeTextBlur"
                            @keydown="onLandscapeTextKeydown"
                            @keyup="onLandscapeTextKeyup"
                        ></textarea>
                        <input
                            v-else
                            type="text"
                            ref="landscapeTextInput"
                            v-model="inputVal"
                            :maxlength="maxlength"
                            dir="ltr"
                            enterkeyhint="next"
                            class="landscape-text-input input-text-ltr"
                            @input="onLandscapeTextInput"
                            @blur="onLandscapeTextBlur"
                            @keydown="onLandscapeTextKeydown"
                            @keyup="onLandscapeTextKeyup"
                        />
                        <button type="button" class="landscape-text-done" tabindex="-1" @mousedown.prevent @click.prevent="doneLandscapeText">{{ textSave }}</button>
                    </form>
                </div>

                <!-- Input -->
                <div class="kind-of" v-else-if="type == 'input'">
                    <p v-show="showingError" class="message-error" v-html="messageError"></p>
                    <input type="text" v-model="inputVal" required />
                </div>

                <!-- SIGNATURE (SIGN)-->
                <div class="kind-of" v-else-if="type == 'sign'">
                    <div class="left hide-scrollbar">
                        <p v-show="message" class="message-info" v-html="message"></p>
                        <p v-show="showingError" class="message-error" v-html="messageError"></p>

                        <ul v-if="orderedEmployeesList" class="list users-list hide-scrollbar">
                            <!-- TODO REVIEW EL IF -->
                            <li v-for="employee in orderedEmployeesList" v-if="employee.conf.sign" class="item user" :class="{ selected: selectedEl == employee.id }" v-bind:data-id="employee.id" @click="selectMe(employee.id)">
                                <span class="user-color"><img class="main-img" v-bind:src="employee.avatar" /></span>
                                <span class="user-name">{{ employee.name }} {{ employee.surname }}</span>
                            </li>
                        </ul>
                        <p v-if="Object.keys(list).length == 0" class="empty" v-html="listEmpty"></p>
                    </div>
                    <div class="right hide-scrollbar" :class="{ disabled: selectedEl == undefined }">
                        <div class="toolbar">
                            <div flat class="btn undo" @click="signUndo">
                                <div class="andy-icon undo"></div>
                                {{ getString('popup.sign.text_undo') }}
                            </div>
                            <div flat class="btn clear" @click="signClear">
                                <div class="andy-icon cancel"></div>
                                {{ getString('popup.sign.text_clear') }}
                            </div>
                        </div>
                        <vueSignature class="signature" ref="ref_sign" :sigOption="signaturePadOptions" :data-msg="disabledMessage" :w="['portrait'].includes($mq) ? '300px' : '600px'" :h="'300px'"></vueSignature>
                    </div>
                </div>

                <!-- Free Signature -->
                <div class="kind-of" v-else-if="type == 'freeSign'">
                    <div class="toolbar">
                        <div flat class="btn undo" @click="signUndo">
                            <div class="andy-icon undo"></div>
                            {{ getString('popup.sign.text_undo') }}
                        </div>
                        <div flat class="btn clear" @click="signClear">
                            <div class="andy-icon cancel"></div>
                            {{ getString('popup.sign.text_clear') }}
                        </div>
                    </div>
                    <vueSignature class="signature" ref="ref_sign" :sigOption="signaturePadOptions" :data-msg="disabledMessage" :w="['portrait'].includes($mq) ? '300px' : '600px'" :h="'300px'"></vueSignature>
                </div>

                <!-- Alerta de Incidencia (en tareas) -->
                <div class="kind-of" v-else-if="type == 'issueAlert'">
                    <p v-if="message" class="alert-message" v-html="message"></p>
                    <p v-if="selectedEl && !selected && selectedItems && selectedItems.length" class="message">
                        <span>{{ getString('popup.issue_alert.suggested_issue') }}</span>
                        <span v-for="(item, index) in selectedItems" :key="item.id">
                            <b>{{ item.name }}</b><template v-if="index < selectedItems.length - 1">, </template>
                        </span>
                    </p>
                    <p v-else-if="!selectedEl && !selected" class="message">{{ getString('popup.issue_alert.suggested_new') }}</p>
                </div>

                <!-- Proceso -->
                <div class="kind-of" v-else-if="type == 'process'">
                    <div class="product-info">
                        <span class="product-title">{{ productName }}</span>
                    </div>

                    <div class="resume hide-scrollbar">
                        <div v-for="(pType, i) in processTypes" @click="changeStep(i)" class="resume-step" :class="[data[i].result ? 'done' : 'undone', { current: currentStep == i }]">
                            <h6 class="title">{{ data[i].title }}</h6>
                            <span class="subtitle">{{ data[i].result ? data[i].result : '' }}</span>
                        </div>
                    </div>

                    <div class="content">
                        <div v-for="(pType, i) in processTypes" class="step hide-scrollbar" :class="[data[i].result ? 'done' : 'undone', { current: currentStep == i }]">
                            <label v-if="typeof data[i].message != 'undefined'" class="step-message" v-html="data[i].message"></label>

                            <div v-if="pType == 'state'" class="tags" :class="'p-' + pType">
                                <span v-for="tag in data[i].tags" class="tag" :key="tag.id" :class="{ selected: data[i].result == tag.name }" @click="setProcessResult(pType, i, tag)">
                                    {{ tag.name }}
                                </span>
                            </div>

                            <div v-else-if="pType == 'date'" class="fcalendar-container" :class="'p-' + pType">
                                <functional-calendar
                                    v-model="data[i].input"
                                    @input="setProcessResult(pType, i, data[i].input)"
                                    :is-multiple="true"
                                    :calendars-count="2"
                                    :isDatePicker="true"
                                    :change-month-function="true"
                                    :change-year-function="true"
                                    :markedDates="[
                                        { date: data[i].maxDate, class: 'expiration' },
                                        { date: data[i].result, class: 'vfc-marked' }
                                    ]"
                                    :limits="{ min: data[i].minDate, max: '' }"
                                ></functional-calendar>
                            </div>

                            <div v-else-if="pType == 'datetime'" class="fcalendar-container" :class="'p-' + pType">
                                <div class="calendar">
                                    <functional-calendar
                                        v-model="data[i].date"
                                        @input="setProcessResult(pType, i, data[i].date)"
                                        :is-multiple="true"
                                        :calendars-count="1"
                                        :isDatePicker="true"
                                        :change-month-function="true"
                                        :change-year-function="true"
                                        :markedDates="[
                                            { date: data[i].maxDate, class: 'expiration' },
                                            { date: data[i].result, class: 'vfc-marked' }
                                        ]"
                                        :limits="{ min: data[i].minDate, max: '' }"
                                    ></functional-calendar>
                                </div>
                                <div class="time">
                                    <span class="message">{{ getString('label.popup.process.pick_time') }}</span>
                                    <input type="time" v-model="data[i].time" @input="setProcessResult(pType, i, data[i].time)" />
                                </div>
                            </div>

                            <div v-else-if="pType == 'string'" class="input-text" :class="'p-' + pType">
                                <input type="text" v-model="data[i].result" v-focus="currentStep == i" required @change="setProcessResult(pType, i, data[i].result)" />
                            </div>

                            <div v-else-if="pType == 'number'" class="input-number" :class="'p-' + pType">
                                <Numpad @sendValue="setProcessValue(pType, i, $event)" :givenValue="data[i].result" :max="data[i].max ? data[i].max : null"></Numpad>
                            </div>

                            <div v-else-if="pType == 'quantity'" class="input-number" :class="'p-' + pType">
                                <Numpad @sendValue="setProcessValue(pType, i, $event)" :givenValue="data[i].result" :max="data[i].max ? data[i].max : null"></Numpad>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Postponer (en tareas) -->
                <div class="kind-of" v-else-if="type == 'postpone'">
                    <div v-if="!showingError" class="postpone-info">
                        <p class="title-date">
                            {{ data.selectedDate == postponeTomorrow ? getString('answer.postpone.pretext_tomorrow') : getStringVariable('answer.postpone.pretext', momentFormat(data.selectedDate.selectedDate)) }}
                        </p>

                        <div class="step-date">
                            <!-- <v-date-picker
                                class="datepicker"
                                v-model="data.selectedDate"
                                :locale="aLocale"
                                landscape
                                reactive
                                :min="dateStart"
                                :max="dateEnd"
                                first-day-of-week="1"
                            ></v-date-picker> -->
                            <functional-calendar v-model="data.selectedDate" :dayNames="getStringObject('calendar.day_names')" :monthNames="getStringObject('calendar.months')" :shortMonthNames="getStringObject('calendar.months')" :isDatePicker="true" :change-month-function="true" :date-format="'yyyy-mm-dd'" :change-year-function="true" :limits="{ min: dateStart, max: dateEnd }"></functional-calendar>
                        </div>

                        <div class="step">
                            <p class="title">
                                <span v-if="data.showErrorReason" class="error">{{ data.errorReason }}</span>
                                {{ getString('answer.postpone.what_reason') }}
                            </p>
                            <ul class="reasons">
                                <li
                                    class="item"
                                    :class="{ selected: selected === item.id }"
                                    v-for="item in list"
                                    @click="
                                        selected = item.id
                                        data.showReason = item.id == '0' ? true : false
                                    "
                                >
                                    {{ getString(item.name) ? getString(item.name) : item.name }}
                                </li>
                            </ul>
                            <p v-if="data.showReason" class="title">{{ getString('answer.postpone.explain_reason') }}</p>
                            <textarea v-if="data.showReason" class="reason_message" v-model="message"></textarea>
                        </div>
                    </div>
                    <div v-else class="postpone-error empty">{{ messageError }}</div>
                </div>

                <!-- Justificar (en tareas) -->
                <div class="kind-of" v-else-if="type == 'justify'">
                    <div v-if="!showingError" class="justify-info">
                        <div class="step">
                            <p class="title" v-if="title" v-html="title"></p>
                            <p class="title" v-else>
                                {{ getString('answer.justify.what_reason') }}
                            </p>
                            <ul class="reasons">
                                <li class="item" :class="{ selected: selected === item.id }" v-for="item in list" @click="selected = item.id">
                                    {{ getString(item.name) ? getString(item.name) : item.name }}
                                </li>
                            </ul>
                        </div>

                        <div class="step">
                            <p class="title" v-if="description" v-html="description"></p>
                            <p class="title" v-else>{{ getString('answer.justify.explain_reason') }}</p>
                            <span v-if="data.showErrorReason" class="error"
                                ><p>{{ data.errorReason }}</p></span
                            >
                            <textarea class="reason_message" v-model="message"></textarea>
                        </div>
                    </div>
                    <div v-else class="justify-error empty">{{ messageError }}</div>
                </div>

                <!-- PLK Add Product -->
                <div class="kind-of" v-else-if="type == 'plsAddProduct'">
                    <PopupPlsAddProduct :productsList="data.productsList ? data.productsList : {}" @save="savePlsAddProduct"></PopupPlsAddProduct>
                </div>

                <!-- PLS Reset -->
                <div class="kind-of" v-else-if="type == 'plsReset'">
                    <PopupPlsReset
                        ref="plsReset"
                        :productsList="data.productsList ? data.productsList : []"
                        :subtitle="message"
                        @editing="plsResetEditing = $event"
                    ></PopupPlsReset>
                </div>

                <!-- PLS Reset confirmation -->
                <div class="kind-of" v-else-if="type == 'plsResetConfirm'">
                    <p class="message" v-html="message"></p>
                </div>

                <!-- PLS Reset loading -->
                <div class="kind-of" v-else-if="type == 'plsResetLoading'">
                    <p class="message" v-html="message"></p>
                </div>

                <!-- Release -->
                <div class="kind-of" v-else-if="type == 'release'">
                    <PopupRelease :data="data"></PopupRelease>
                </div>

                <!-- RENEW -->
                <div class="kind-of" v-else-if="type == 'renew'" :class="$mq">
                    <p class="title" v-if="title" v-html="title"></p>
                    <p class="message" v-if="message" v-html="message"></p>
                </div>

                <!-- LIST AUDITS -->
                <div class="kind-of" v-else-if="type == 'list_audits'">
                    <template v-if="Object.keys(list).length > 0">
                        <div class="full hide-scrollbar">
                            <p v-show="message" class="message-info" v-html="message"></p>
                            <p v-show="showingError" class="message-error" v-html="messageError"></p>

                            <SearchBar :search="search" @on-search="searchBarInput" @on-button-click="cleanSearch" :placeholder="getString('popup.audits.search_placeholder')" />
                            <ul v-if="Object.keys(list).length > 0" class="list audit-list">
                                <li
                                    v-for="(item, key) in filteredList"
                                    :key="key"
                                    class="item audit"
                                    :class="{
                                        selected: selectedEl == item.id,
                                        supervisor: typeof item.config.level === 'undefined' || item.config.level > level
                                    }"
                                    v-bind:data-id="item.id"
                                    @click="selectMe(item.id, key)"
                                >
                                    <span class="audit">{{ item.name }}</span>
                                </li>
                            </ul>
                            <p v-if="Object.keys(list).length == 0" class="empty" v-html="listEmpty"></p>
                        </div>
                    </template>

                    <template v-else>
                        <p class="message">{{ getString('tooltip.error_logout') }}</p>
                    </template>
                </div>

                <!-- Email alert -->
                <div class="kind-of" v-else-if="type == 'emailAlert'">
                    <p class="message" :class="type" v-html="emailAlertMessage"></p>
                </div>

                <!-- Item settings  -->
                <div class="kind-of item-settings" v-else-if="type == 'itemSettings'">
                    <div class="title">
                        {{ title }}
                    </div>
                    <div v-if="itemSettings">
                        <div class="form-container item-settings">
                            <div class="form-content">
                                <div class="field-form in-line" v-for="item in Object.values(itemSettings)">
                                    <label class="switch">
                                        <input type="checkbox" v-model="item.value" @click="item.value = !item.value" />
                                        <div class="slider round" :class="[$mq]"></div>
                                    </label>
                                    <div class="label-alarm">
                                        {{ item.label }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="kind-of" v-else-if="type == 'action-plan-create'">
                    <p v-if="tplName" class="message">
                        <span>{{ getString('popup.action_plan_create.message') }}</span>
                        <span>
                            <b> {{ tplName }}</b>
                        </span>
                    </p>
                    <p v-else class="message">{{ getString('popup.action_plan_create.message2') }}.</p>
                </div>

                <div class="kind-of" v-else-if="type == 'screenlock'">
                    <p class="message screenlock-message" v-if="message" v-html="message"></p>
                </div>

                <div class="kind-of" v-else-if="type == 'screenlockUserLevelOne'">
                    <p class="message screenlock-message" v-if="message" v-html="message"></p>
                </div>

                <!-- product info-->
                <div class="kind-of product-info" v-else-if="type == 'productInfo'">
                    <div class="product">
                        <div class="icon" :style="{ backgroundImage: 'url(' + productIcon + ')' }"></div>
                        <div class="text">
                            <span class="title">{{ productName }}</span>
                            <span class="subtitle">{{ productContainer }}</span>
                        </div>
                    </div>
                    <div class="content">
                        <div class="text">
                            <span class="title">{{ getString('popup.product_info.projected_production') }}</span>
                            <span class="subtitle">{{ getString('popup.product_info.projected_production_difference') }}</span>
                            <span class="title">{{ getString('popup.product_info.real_production') }}</span>
                            <span class="subtitle">{{ getString('popup.product_info.real_production_difference') }}</span>
                            <span class="title">{{ getString('popup.product_info.remaining_production') }}</span>
                        </div>
                        <div class="value">
                            <span class="title">{{ projectedProduction }}</span>
                            <span class="subtitle">{{ projectedProductionDifference }}</span>
                            <span class="title">{{ realProduction }}</span>
                            <span class="subtitle">{{ realProductionDifference }}</span>
                            <span class="title">{{ remainingProduction }}</span>
                        </div>
                    </div>
                </div>

                <!-- Projection -->
                <div class="kind-of projection" v-else-if="type == 'projection'">
                    <div class="title">
                        <div class="icon"></div>
                        <span>{{ title }}</span>
                    </div>
                    <div class="text">
                        <span>{{ description }}</span>
                        <span>{{ getString('popup.product_info.projection.description2') }}</span>
                    </div>
                </div>
                <!-- Projection Return -->
                <div class="kind-of projection-return" v-else-if="type == 'projectionReturn'">
                    <div class="title">
                        <div class="icon"></div>
                        <span>{{ title }}</span>
                    </div>
                    <div class="text">
                        <span>{{ description }}</span>
                        <span>{{ getString('popup.product_info.projection.description2') }}</span>
                    </div>
                </div>

                <!-- basico, confirmUpload, alert, delete... -->
                <div class="kind-of phu-assign" v-else-if="type == 'phuAssign'">
                    <PopupPhuAssign
                        :title="title"
                        :phus="assignPhus"
                        :workstations="assignMeta.workstations"
                        :products="assignMeta.products"
                        :product-id="assignMeta.productId"
                        :units="assignMeta.units"
                        :workstation-id="assignMeta.workstationId"
                        :now="assignMeta.now"
                        :selected-id="selectedEl"
                        @select="selectedEl = $event"
                    />
                </div>

                <div class="kind-of phu-product" v-else-if="type == 'phuProduct'">
                    <h2 class="phu-product__title">{{ title }}</h2>
                    <label class="phu-product__search">
                        <i class="i-andy-search-aaaaa i-andy-sm" aria-hidden="true"></i>
                        <input v-model="search" type="search" :placeholder="getString('phu_production.configuration.search_product')" :aria-label="getString('phu_production.configuration.search_product')" />
                    </label>
                    <div class="phu-product__grid">
                        <button v-if="phuShowsEmpty" type="button" class="phu-product__card" :class="{ 'is-selected': isPhuSelected(null) }" :aria-pressed="isPhuSelected(null)" @click="selectPhuProduct(null)">
                            <i class="i-andy-close i-andy-l" aria-hidden="true"></i>
                            <span class="phu-product__name">{{ getString('phu_production.configuration.empty_slot') }}</span>
                        </button>
                        <button v-for="product in phuVisibleProducts" :key="product.id" type="button" class="phu-product__card" :class="{ 'is-selected': isPhuSelected(product.id), 'is-disabled': product.disabled }" :disabled="product.disabled" :aria-pressed="isPhuSelected(product.id)" @click="selectPhuProduct(product.id)">
                            <img v-if="product.image" class="phu-product__image" :src="product.image" alt="" />
                            <span v-else class="phu-product__image" aria-hidden="true"></span>
                            <span class="phu-product__name">{{ product.name }}</span>
                            <span v-if="product.disabled && product.disabledLabel" class="phu-product__disabled">{{ product.disabledLabel }}</span>
                        </button>
                    </div>
                </div>

                <!-- Recommendation review (BUILD-7486). Isolated: other types still hit v-else. -->
                <div class="kind-of recommendation-body" v-else-if="type == 'recommendation'">
                    <p class="recommendation-copy" v-if="message" v-html="message"></p>
                    <ul v-if="recommendationProducts && recommendationProducts.length" class="recommendation-products">
                        <li v-for="product in recommendationProducts" :key="product.id" class="recommendation-product">
                            <img v-if="product.image" class="recommendation-product-image" :src="product.image" alt="" />
                            <span v-else class="recommendation-product-fallback" aria-hidden="true"></span>
                            <span class="recommendation-product-name">{{ product.name }}</span>
                        </li>
                    </ul>
                </div>

                <div class="kind-of phu-waste" v-else-if="type == 'phuWaste'">
                    <div class="phu-waste__product">
                        <img v-if="productUrl" class="phu-waste__image" :src="productUrl" alt="" />
                        <p class="phu-waste__name">{{ productName }}</p>
                    </div>
                    <p v-if="wastePrompt" class="phu-waste__message">{{ wastePrompt }}</p>
                    <p v-else-if="productMessage" class="phu-waste__message">{{ productMessage }}</p>
                    <div class="phu-waste__keyboard">
                        <Numpad @sendValue="changeValue" @saveAndClose="save" :sensorType="tempOptions.sensorType" :givenValue="inputVal" :decimal="false" :hasNegative="false" :pinType="'numeric'" :newDesing="true" :quantity="true" :max="numericNewDesing.max" :min="1" :preventMobileKeyboard="true"></Numpad>
                        <button type="button" class="phu-waste__cancel" @click="cancel('cross')">{{ textCancel }}</button>
                    </div>
                </div>

                <div class="kind-of phu-no-equipment" v-else-if="type == 'phuNoEquipment'">
                    <span class="phu-no-equipment__badge" aria-hidden="true">
                        <i class="i-andy-menu-task i-andy-l"></i>
                    </span>
                    <p class="phu-no-equipment__title">{{ title }}</p>
                    <p class="phu-no-equipment__message">{{ message }}</p>
                </div>

                <div class="kind-of" v-else>
                    <p class="message" v-if="message" v-html="message"></p>
                    <span class="audit-score" v-if="customClass.toString().includes('auditPoints')">{{ data }}%</span>
                </div>
            </div>
            <div class="pop-footer" v-if="type != 'resource' && type != 'plsAddProduct' && type != 'numericNewDesing' && type != 'phuWaste' && type != 'plsResetLoading' && type != 'textInputLandscape'">
                <div v-if="type == 'process'" class="buttons">
                    <button @click="changeStep(currentStep - 1)" v-if="currentStep > 0" class="act prev" :class="classPrev" v-html="textPrev"></button>
                    <button @click="cancel('button')" class="act cancel logout" :class="classCancel" v-html="textCancel"></button>
                    <button @click="save" v-if="currentStep == data.length - 1" class="act save" :class="classSave" v-html="textSave"></button>
                    <button @click="changeStep(currentStep + 1)" v-if="currentStep < data.length - 1" class="act next" :class="classNext" v-html="textNext"></button>
                </div>
                <!-- <div v-if="type == 'message'" class="buttons">
                    <button @click="save" class="act" :class="classSave" v-html="textSave"></button>
                </div> -->
                <div v-if="type == 'messageNewDesing'" class="buttons">
                    <button @click="save" class="act save" :class="classSave" v-html="textSave"></button>
                    <button @click="cancel('button')" class="act cancel" :class="classCancel" v-html="textCancel" v-if="textCancel"></button>
                </div>
                <div v-else-if="type == 'issueAlert'" class="buttons">
                    <button @click="saveStart" class="act save" :class="classSaveStart" v-html="textSaveStart" v-if="!selected && showSaveStart"></button>
                    <button @click="save" class="act" :class="[selected ? 'save' : 'cancel', classSave]" v-html="textSave"></button>
                </div>
                <div v-else-if="type == 'renew'" class="buttons">
                    <button @click="cancel('button')" class="act save" v-html="textSave"></button>
                </div>
                <div v-else-if="type == 'offlineAlert'" class="buttons">
                    <button @click="cancel('button')" class="act save" v-html="textSave"></button>
                </div>
                <div v-else-if="type == 'login' && Object.keys(list).length == 0" class="buttons">
                    <button @click="logoutStore" class="act save">{{ getString('popup.login.text_logout') }}</button>
                </div>
                <div v-else-if="type == 'list_audits'" class="buttons">
                    <button @click="cancel('button')" class="act cancel" :class="classCancel" v-html="textCancel" v-if="type != 'alert'"></button>
                    <button @click="save" class="act save" :class="classSave" v-html="selectedEl != undefined && (typeof list[selectedPos].config.level === 'undefined' || list[selectedPos].config.level > level) ? textSaveSupervisor : textSave"></button>
                </div>
                <div v-else-if="type == 'disconnect'" class="buttons">
                    <button @click="cancel('button')" class="act cancel" :class="classCancel" v-html="textCancel" v-if="type != 'alert'"></button>
                    <button @click="save" class="act save" :class="classSave" :disabled="type == 'phuAssign' && !selectedEl" v-html="textSave" v-if="type != 'media' && type != 'library' && !(type == 'select' && cType == 4)"></button>
                </div>
                <div v-else-if="['temperature', 'numeric'].includes(type) && ['all', 'sensor'].includes(tempOptions.sensorType)" class="buttons">
                    <button @click="cancel('button')" class="act notNow" v-html="textNotNow" v-if="[3, 4].includes(tempSensorStep)"></button>
                    <button @click="cancel('button')" class="act cancel" v-html="textCancel" v-if="tempSensorStep == 1"></button>
                    <button @click="save" class="act save" v-html="textSave" v-if="[2, 4].includes(tempSensorStep)"></button>
                </div>
                <div v-else-if="type === 'media'" class="buttons">
                    <template v-if="caption">
                        <button @click="cancel('button')" class="act cancel" :class="classCancel">{{ textCancel || getString('popup.media.text_cancel') }}</button>
                    </template>
                    <template v-else>
                        <button @click="cancel('button')" class="act cancel" :class="classCancel">{{ getString('menu_aux.action.cancel') }}</button>
                        <button v-if="!$data.logbook && showDeleteButton" @click="imgDelete" class="act save">{{ getString('menu_aux.action.delete') }}</button>
                    </template>
                </div>
                <div v-else-if="type === 'previewSignature'" class="buttons">
                    <button @click="cancel('button')" class="act cancel" :class="classCancel">{{ getString('popup.media.text_cancel') }}</button>
                </div>
                <div v-else-if="type === 'screenlock'" class="buttons">
                    <button @click="save" class="act save" :class="classSave">{{ getString('popup.access.text_save') }}</button>
                </div>
                <div v-else-if="type === 'screenlockUserLevelOne'" class="buttons screenlock-message-kind-of">
                    <div class="alert keep-format">
                        <div class="alex"></div>
                        {{ getString('popup.screenlock.user_level_one') }}
                    </div>
                    <button @click="save" class="act save" :class="classSave">{{ getString('popup.access.change_user') }}</button>
                </div>
                <div v-else-if="type === 'itemSettings'" class="buttons">
                    <button @click="cancel('button')" class="act cancel" :class="classCancel">{{ getString('menu_aux.action.cancel') }}</button>
                    <button @click="save" class="act save" :class="classSave">{{ getString('menu_aux.action.save') }}</button>
                </div>
                <div v-else-if="type === 'productInfo'" class="buttons">
                    <button @click="cancel('button')" class="act cancel productInfo" :class="classCancel">{{ getString('popup.product_info.text_close') }}</button>
                </div>
                <div v-else-if="type === 'projectionReturn'" class="buttons">
                    <button @click="timeoutAction()" class="act cancel projectionReturn" :class="classCancel">{{ getString('popup.product_info.projection.text_close') }}</button>
                </div>
                <div v-else-if="type == 'recommendation'" class="buttons">
                    <button type="button" @click="cancel('button')" class="act cancel" :class="classCancel" v-html="textCancel"></button>
                    <button type="button" @click="cancel2('button')" class="act cancel" :class="classCancel" v-html="textCancel2" v-if="textCancel2"></button>
                    <button type="button" @click="save" class="act save" :class="classSave" v-html="textSave"></button>
                </div>
                <div v-else-if="type != 'projection'" class="buttons">
                    <button @click="cancel2('button')" class="act cancel" :class="[classCancel]" v-html="textCancel2" v-if="textCancel2"></button>
                    <button @click="cancel('button')" :class="[{ 'act save': classSave }, { 'act cancel': !classSave }, { full: type == 'confirmUpload' }]" v-html="textCancel" v-if="type != 'alert'"></button>
                    <button @click="saveStart" class="act save start" :class="classSaveStart" v-html="textSaveStart" v-if="type == 'select' || type == 'selectDouble' || type == 'confirmUpload'"></button>
                    <button @click="save" class="act save" :class="classSave" :disabled="phuSaveDisabled" v-html="textSave" v-if="type != 'media' && type != 'library' && !(type == 'select' && cType == 4)"></button>
                    <!-- <button @click="logout" class="act logout" :class="classLogout" v-html="textLogout" v-if="type == 'login'"></button> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'
import Numpad from '@/components/inputs/Numpad'
import PopupTemperature from '@/plugins/popup/PopupTemperature'
import PopupTicket from '@/plugins/popup/PopupTicket'
import PopupDateTime from '@/plugins/popup/PopupDateTime'
import PopupRelease from '@/plugins/popup/PopupRelease'
import PopupGeolocation from '@/plugins/popup/PopupGeolocation'
import PopupResource from '@/plugins/popup/PopupResource'
import PopupPlsAddProduct from '@/plugins/popup/PopupPlsAddProduct'
import PopupPlsReset from '@/plugins/popup/PopupPlsReset'
import PopupPhuAssign from '@/plugins/popup/PopupPhuAssign.vue'
import SearchBar from '../../components/domain/ui/SearchBar.vue'
import LottieAnimation from '@/components/layout/LottieAnimation.vue'

import i18n from '@/i18n'
import { isScreenRotationInProgress } from '@/utils/screen'
import { TYPE } from '@/constants'
import draggable from 'vuedraggable'
import store from '@/store'
import router from '@/router'
import LibraryDetail from '@/components/domain/library/detail'

import vueSignature from 'vue-signature'
Vue.use(vueSignature)
export default {
    components: {
        LottieAnimation,
        PopupTemperature,
        PopupTicket,
        LibraryDetail,
        Numpad,
        PopupDateTime,
        PopupRelease,
        PopupGeolocation,
        PopupResource,
        SearchBar,
        draggable,
        PopupPlsAddProduct,
        PopupPlsReset,
        PopupPhuAssign
    },
    data() {
        return {
            mood: 'normal',
            decimal: false,
            show: false,
            hasNegative: false,
            closable: true,
            blocking: true,
            type: '',
            title: '',
            message: '',
            messageError: '',
            showingError: false,
            list: [],
            recommendationProducts: [],
            level: 3,
            listSec: {},
            listEmpty: '',
            textLogout: '',
            textCancel: '',
            textCancel2: '',
            textNotNow: '',
            textSave: '',
            textSaveSupervisor: '',
            textSaveStart: '',
            textNext: '',
            textPrev: '',
            classLogout: '',
            classCancel: '',
            classSave: '',
            classSaveStart: '',
            classNext: '',
            classPrev: '',
            inputVal: '',
            productName: '',
            productUrl: '',
            productMessage: '',
            image: false,
            file: false,
            caption: '',
            selected: false,
            selectedSec: false,
            selectedEl: undefined,
            selectedIssueEl: undefined,
            selectedPos: undefined,
            selectedSecEl: undefined,
            selectedTab: '',
            selectedSecTab: '',
            disabledMessage: '',
            disNumpad: false,
            dateRange: {},
            dateRangeTwo: {},
            dateStart: '',
            dateEnd: '',
            processData: {},
            processTypes: [],
            currentStep: 0,
            data: [],
            cType: false,
            customClass: '',
            date: '',
            time: '',
            resource: false,
            oldDate: '',
            oldTime: '',
            hasSignature: false,
            signOptions: {
                penColor: '',
                backgroundColor: '',
                format: '',
                watermark: ''
            },
            tempOptions: {
                maxRange: null,
                minRange: null,
                maxNum: 260,
                minNum: -40,
                stepNum: 1,
                numDec: 1,
                stepDec: 1,
                mesure: 'ºC'
            },
            itemSettings: {},
            tempSensorStep: 1,
            routePath: false,
            showSaveStart: true,
            updatedDayCalendarOne: 0,
            updatedDayCalendarTwo: 0,
            productName: null,
            wasteUnitsPrompt: false,
            productContainer: null,
            productIcon: null,
            projectedProduction: null,
            realProduction: null,
            remainingProduction: null,
            projectedProductionDifference: null,
            realProductionDifference: null,
            callLogout: function () {},
            callCancel: function () {},
            callCancel2: function () {},
            callSave: function () {},
            callSaveStart: function () {},
            callEdit: function () {},
            callDelete: function () {},
            callRemoveAll: function () {},
            callAfterAccess: function () {},
            onSuccess: null,
            columnHeaders: null,
            searchBar: false,
            search: '',
            timerSearch: false,
            newHeaders: [],
            tablePopup: '',
            options: [],
            numericNewDesing: {
                max: 100
            },
            disabledAlexIcon: ['tableColumn', 'media', 'select', 'phuProduct', 'phuAssign', 'phuNoEquipment', 'library', 'resource', 'emailAlert', 'renew', 'itemSettings', 'productInfo', 'projection', 'projectionReturn', 'message', 'printConfig', 'plsAddProduct', 'plsReset', 'plsResetConfirm', 'plsResetLoading', 'numericNewDesing', 'phuWaste', 'messageNewDesing', 'issueAlert', 'textInputLandscape'],
            multiline: true,
            maxlength: 512,
            imeAdvance: false,
            landscapeClosing: false,
            landscapeAdvanceOnClose: false,
            landscapeSubmitting: false,
            landscapeFullHeight: 0,
            landscapeKeyboardWasOpen: false,
            landscapeViewportHandler: null,
            landscapeWindowResizeHandler: null,
            landscapeBackButtonHandler: null,
            callInput: function () {},
            only_past: false,
            tplName: null,
            description: null,
            timeout: {
                action: {
                    actionText: i18n.t('assets.overlay.timeout.actionText'),
                    message: i18n.t('assets.overlay.timeout.message'),
                    show: false,
                    url: '/home',
                    callAction: function () {}
                }
            },
            showDeleteButton: true,
            bReadingFromSensor: false,
            plsResetEditing: false
        }
    },
    computed: {
        signaturePadOptions() {
            return {
                ...this.signOptions,
                onEnd: this.updateSignatureState
            }
        },
        isSignatureSaveDisabled() {
            return (this.type == 'sign' || this.type == 'freeSign') && (!this.hasSignature || (this.type == 'sign' && this.selectedEl == undefined))
        },
        loginDisabledMessage() {
            return i18n.t('popup.login.select_user')
        },
        aLocale() {
            var language = store.getters['getLanguage']
            parseLang(language)
            return language
            // return store.getters['getLocale']
        },
        postponeTomorrow() {
            return moment(this.dateStart).format('YYYY-MM-DD')
        },
        dateRangeFirstCalendar() {
            return this.dateRange
        },
        phuVisibleProducts() {
            if (this.type !== 'phuProduct' || !Array.isArray(this.list)) {
                return []
            }
            const query = String(this.search || '').trim().toLowerCase()
            return this.list.filter((item) => !query || String(item.name || '').toLowerCase().indexOf(query) !== -1)
        },
        assignPhus() {
            return this.type === 'phuAssign' && Array.isArray(this.list) ? this.list : []
        },
        assignMeta() {
            if (this.type !== 'phuAssign' || !this.data || Array.isArray(this.data)) {
                return { workstations: [], products: {}, productId: null, units: 0, workstationId: null, now: Date.now() }
            }
            return {
                workstations: this.data.workstations || [],
                products: this.data.products || {},
                productId: this.data.productId,
                units: Number(this.data.units) || 0,
                workstationId: this.data.workstationId,
                now: this.data.now || Date.now()
            }
        },
        phuSaveDisabled() {
            if (this.type === 'phuAssign') {
                return !this.selectedEl
            }
            if (this.type === 'phuProduct' && this.data && this.data.hideEmpty) {
                return !this.selectedEl
            }
            return false
        },
        wastePrompt() {
            if (this.type !== 'phuWaste' || !this.wasteUnitsPrompt) {
                return ''
            }
            const units = parseInt(this.inputVal, 10) || 0
            return this.$tc('phu_production.waste.slot_message', units, {
                units,
                product: this.productName || ''
            })
        },
        phuShowsEmpty() {
            if (this.type !== 'phuProduct' || (this.data && this.data.hideEmpty)) {
                return false
            }
            const query = String(this.search || '').trim().toLowerCase()
            if (!query) {
                return true
            }
            return String(i18n.t('phu_production.configuration.empty_slot')).toLowerCase().indexOf(query) !== -1
        },
        filteredList() {
            if (this.search === '') {
                return this.list
            } else {
                return this.list.filter((item) => item.name.toLowerCase().includes(this.search.toLowerCase()))
            }
        },
        orderedEmployeesList() {
            if (!this.list) {
                return null
            }

            const employeesList = Object.values(this.list)

            if (employeesList.length === 0) {
                return null
            }

            const orderedList = employeesList.sort(this.compareNames)

            return orderedList
        },
        selectedItems() {
            const arr = Array.isArray(this.list) ? this.list : Object.values(this.list || {})
            if (Array.isArray(this.selectedIssueEl)) {
                return arr.filter((item) => this.selectedIssueEl.includes(item.id))
            } else if (this.selectedIssueEl) {
                const found = arr.find((item) => item.id === this.selectedIssueEl)
                return found ? [found] : []
            } else {
                return []
            }
        },
        emailAlertMessage() {
            if (!this.message || this.type !== 'emailAlert') {
                return this.message
            }

            return this.message.replace(/<\s*b\s*>([^<]*)<\s*\/\s*b\s*>/gi, (fullMatch, content) => {
                if (!content.includes('@')) {
                    return fullMatch
                }

                const withSpacing = content.replace(/,(?!\s)/g, ', ')
                return '<b class="email-alert-list">' + withSpacing + '</b>'
            })
        }
    },
    methods: {
        checkHeader(header) {
            header.visible = !header.visible
            this.$forceUpdate()
        },

        tempUpdateSensorStep(newVal) {
            log('tempUpdateSensorStep', newVal)
            this.tempSensorStep = newVal
        },
        redirectPath(firstResult) {
            var visible = []
            var tools = store.getters['getTools']
            var result = firstResult
            const config = store.getters['login/getConfig']

            if (config.tools) {
                visible = config.tools
            }
            if (visible.length == 1) {
                result = tools[visible[0]].href
            }

            return result
        },

        momentFormat(date) {
            return moment(date).format('dddd D')
        },
        dayClickedCalendarOne(e) {
            this.updatedDayCalendarOne++
        },
        dayClickedCalendarTwo(e) {
            this.updatedDayCalendarTwo++
        },

        selectPhuProduct(id) {
            this.selectedEl = id
        },
        isPhuSelected(id) {
            if (id === null) {
                return this.selectedEl === null
            }
            return String(this.selectedEl) === String(id)
        },
        selectMe(id, key) {
            this.selected = id
            this.changeValue('')
            if (this.selectedEl == id) {
                this.disNumpad = true
                this.selectedEl = undefined
            } else {
                this.disNumpad = false
                this.selectedEl = id
            }
            if (typeof key !== 'undefined') this.selectedPos = key
        },
        selectMeSec(id) {
            this.selectedSec = id
            this.changeValue('')
            if (this.selectedSecEl == id) {
                this.disNumpad = true
                this.selectedSecEl = undefined
            } else {
                this.disNumpad = false
                this.selectedSecEl = id
            }
        },
        selectTab(id) {
            this.selectedTab = id
            this.selected = undefined
            this.selectedEl = undefined
            this.disNumpad = true
            this.changeValue('')
            this.showingError = false
        },

        changeValue(newVal, bFromSensor = false) {
            this.bReadingFromSensor = bFromSensor
            if (this.type == 'numericNewDesing' || this.type == 'phuWaste') {
                log('changeValue', newVal, this.numericNewDesing.max)
                if (newVal > this.numericNewDesing.max) {
                    this.inputVal = this.numericNewDesing.max
                } else {
                    this.inputVal = newVal
                }
            } else {
                this.inputVal = newVal
            }
        },

        getString(str) {
            return i18n.t(str)
        },
        getStringObject(str, obj) {
            return i18n.t(str, obj)
        },
        getStringPlural(str, pos) {
            return i18n.tc(str, pos)
        },
        getStringVariable(str, pos) {
            return i18n.t(str, { s: pos })
        },
        getStringPluralVariable(str, pos, text) {
            return i18n.tc(str, pos, { s: text })
        },

        // Para limitar fechas (ver vuetify)
        // allowedDates: val => parseInt(val.split('-')[2], 10) % 2 === 0,

        onContainerClick() {
            if (this.type === 'textInputLandscape') {
                this.confirmLandscapeText(false)
            } else {
                this.cancel()
            }
        },

        initLandscapeTextPopup() {
            const vv = window.visualViewport
            this.landscapeFullHeight = vv ? vv.height : window.innerHeight || 0
            this.landscapeKeyboardWasOpen = false
            this.updateLandscapeTextHeight()

            if (vv) {
                this.landscapeViewportHandler = () => {
                    this.updateLandscapeTextHeight()
                    this.checkLandscapeKeyboardHidden()
                }
                vv.addEventListener('resize', this.landscapeViewportHandler)
            } else {
                this.landscapeWindowResizeHandler = () => {
                    this.updateLandscapeTextHeight()
                    this.checkLandscapeKeyboardHidden()
                }
                window.addEventListener('resize', this.landscapeWindowResizeHandler)
            }

            this.landscapeBackButtonHandler = (e) => {
                e.preventDefault()
                e.stopImmediatePropagation()
                this.confirmLandscapeText(false)
            }
            document.addEventListener('backbutton', this.landscapeBackButtonHandler, true)

            this.$nextTick(() => {
                const el = this.$refs.landscapeTextInput
                if (el) {
                    el.focus({ preventScroll: true })
                }
            })
        },

        cleanupLandscapeTextPopup() {
            if (window.visualViewport && this.landscapeViewportHandler) {
                window.visualViewport.removeEventListener('resize', this.landscapeViewportHandler)
                this.landscapeViewportHandler = null
            }

            if (this.landscapeWindowResizeHandler) {
                window.removeEventListener('resize', this.landscapeWindowResizeHandler)
                this.landscapeWindowResizeHandler = null
            }

            if (this.landscapeBackButtonHandler) {
                document.removeEventListener('backbutton', this.landscapeBackButtonHandler, true)
                this.landscapeBackButtonHandler = null
            }

            document.documentElement.style.removeProperty('--landscape-text-height')
        },

        checkLandscapeKeyboardHidden() {
            const vv = window.visualViewport
            const current = vv ? vv.height : window.innerHeight || 0
            this.landscapeFullHeight = Math.max(this.landscapeFullHeight, current)

            const keyboardOpen = current < this.landscapeFullHeight - 100

            if (keyboardOpen) {
                this.landscapeKeyboardWasOpen = true
            } else if (
                this.landscapeKeyboardWasOpen &&
                !this.landscapeSubmitting &&
                !this.landscapeClosing &&
                !isScreenRotationInProgress()
            ) {
                // Android "siguiente" suele ocultar el teclado sin Enter
                this.confirmLandscapeText(!!this.imeAdvance)
            }
        },

        updateLandscapeTextHeight() {
            const vv = window.visualViewport
            const full = window.innerHeight || (vv ? vv.height : 0)
            let height = Math.round(full * 0.5)

            if (vv && vv.height < full - 100) {
                height = vv.height
            }

            document.documentElement.style.setProperty('--landscape-text-height', `${height}px`)
        },

        doneLandscapeText() {
            this.submitLandscapeText(false)
        },

        submitLandscapeText(advance = true) {
            if (this.landscapeClosing) {
                return
            }

            this.landscapeSubmitting = true
            this.landscapeAdvanceOnClose = !!advance

            const el = this.$refs.landscapeTextInput
            if (el && document.activeElement === el) {
                el.blur()
            }

            this.confirmLandscapeText(!!advance)
        },

        confirmLandscapeText(advance = false) {
            if (this.landscapeClosing) {
                return
            }

            this.landscapeClosing = true
            this.landscapeAdvanceOnClose = !!advance

            try {
                this.callSave(this, store)
            } catch (e) {
                // continuar al cierre aunque falle el guardado
            }

            this.callCancel(this, store)
        },

        onLandscapeTextInput() {
            if (typeof this.callInput === 'function') {
                this.callInput(this, store)
            }
        },

        isLandscapeAdvanceKey(e) {
            if (e.shiftKey) {
                return false
            }

            const key = e.key
            const code = e.keyCode || e.which

            return key === 'Enter' || key === 'Next' || key === 'Go' || code === 13 || code === 10
        },

        onLandscapeTextKeydown(e) {
            if (!this.isLandscapeAdvanceKey(e)) {
                return
            }

            e.preventDefault()
            this.submitLandscapeText(true)
        },

        onLandscapeTextKeyup(e) {
            if (!this.isLandscapeAdvanceKey(e)) {
                return
            }

            e.preventDefault()
            this.submitLandscapeText(true)
        },

        onLandscapeTextBlur() {
            if (this.landscapeClosing || this.landscapeSubmitting) {
                this.landscapeSubmitting = false
                return
            }

            // Si imeAdvance, el blur de "siguiente" debe guardar y saltar
            this.confirmLandscapeText(!!this.imeAdvance)
        },

        cancel(item) {
            // check if is closable or if is legal_conditions, click in cancel button
            if (this.closable || (item == 'button' && this.customClass == 'popup-small')) {
                item = item || false
                this.callCancel(this, store, item)
            } else if (item == 'cross') {
                this.callCancel(this, store, item)
            }
        },

        cancel2(item) {
            this.callCancel2(this, store, item)
        },

        save() {
            if (this.type === 'phuAssign' && !this.selectedEl) {
                return
            }
            if (this.type == 'sign' || this.type == 'freeSign') {
                this.signSave()
            } else if (this.type == 'process') {
                var finish = []
                for (var k in this.data) {
                    var d = this.data[k]
                    if (d.optional || (d.result && d.result != null && d.result != '')) {
                        finish.push('true')
                    } else {
                        finish.push('false')
                    }
                }
                if (finish.indexOf('false') == -1) {
                    this.callSave(this, store)
                }
            } else if (this.type == 'ticket') {
                let formData = this.$refs['popupTicket'].validateForm()
                let self = this

                if (formData) {
                    // show loader
                    self.$overlay.loading({
                        blocking: true
                    })

                    // prepare data
                    let params = {
                        location_id: formData.location_id,
                        employee_id: '',
                        tool: formData.tool,
                        description: formData.description,
                        email: formData.email,
                        data: {
                            location: formData.location,
                            name: formData.employee_id
                        }
                    }

                    // store add ticket
                    store.dispatch('ticket/addTicket', params).then(function (response) {
                        // close loader
                        self.$overlay.hide()

                        // return event result
                        self.callSave(this, store)
                    })
                }
            } else if (this.type == 'dateTime') {
                const data = this.$refs['dateTime'].getData()
                this.date = data.date
                this.time = data.time
                this.oldDate = data.oldDate
                this.oldTime = data.oldTime
                this.callSave(this, store)
            } else if (this.type == 'tableColumn') {
                // save Supervise table columns order
                this.$data.headers = this.columnHeaders

                this.$forceUpdate()
                this.callSave(this, store)
            } else {
                this.callSave(this, store)
            }
        },
        saveStart() {
            this.callSaveStart(this, store)
        },
        logout() {
            this.callLogout(this, store)
        },
        logoutStore() {
            router.push('/login')
            this.callCancel(this, store)
        },
        savePlsAddProduct({ product, quantity }) {
            // Validar que tenemos producto y cantidad válidos
            if (!product || !quantity || quantity <= 0) {
                console.warn('Producto o cantidad inválidos:', { product, quantity })
                return
            }

            // Asignar el valor al inputVal para que esté disponible en el callSave
            this.inputVal = { product, quantity }

            // Ejecutar el callback de guardado
            this.callSave(this, store, { product, quantity })
        },

        // Funciones propias de SIGN
        updateSignatureState() {
            this.hasSignature = !!this.$refs.ref_sign && !this.$refs.ref_sign.isEmpty()
        },
        signSave() {
            if ((this.type == 'sign' && this.selectedEl == undefined) || !this.$refs.ref_sign || this.$refs.ref_sign.isEmpty()) {
                return
            }

            if (typeof this.list[this.selectedEl] !== 'undefined') {
                this.signAddWaterMark()
            }

            if (this.signOptions.format == 'jpg') {
                this.inputVal = this.$refs.ref_sign.save('image/jpeg')
            } else if (this.signOptions.format == 'svg') {
                this.inputVal = this.$refs.ref_sign.save('image/svg+xml')
            } else if (this.signOptions.format == 'png') {
                this.inputVal = this.$refs.ref_sign.save()
            } else {
                // Guarda en PNG
                this.inputVal = this.$refs.ref_sign.save()
            }
            this.callSave(this, store)
        },
        signClear() {
            this.$refs.ref_sign.clear()
            this.updateSignatureState()
        },
        signUndo() {
            this.$refs.ref_sign.undo()
            this.updateSignatureState()
        },
        signAddWaterMark() {
            this.$refs.ref_sign.addWaterMark({
                text: i18n.t('popup.sign.watermark') + this.list[this.selectedEl].name,
                font: '12px Arial',
                x: 10,
                y: 180
                // -- All properties
                // text:"mark text",          // watermark text, > default ''
                // font:"20px Arial",         // mark font, > default '20px sans-serif'
                // style:'all',               // fillText and strokeText,  'all'/'stroke'/'fill', > default 'fill
                // fillStyle:"#333333",           // fillcolor, > default '#333'
                // strokeStyle:"blue",	       // strokecolor, > default '#333'
                // x:100,                     // fill positionX, > default 20
                // y:200,                     // fill positionY, > default 20
                // sx:100,                    // stroke positionX, > default 40
                // sy:200,                     // stroke positionY, > default 40
            })
        },
        signFromDataURL(url) {
            this.$refs.ref_sign.fromDataURL('data:image/png;base64,iVBORw0K...')
        },

        // Funciones propias de process
        generateProcess() {
            var self = this

            var label = self.processData ? self.processData.label : false
            var selectedState = self.processData && Object.keys(self.processData.selectedState).length > 0 ? self.processData.selectedState : { id: label.states[Object.keys(label.states)[0]].id, name: label.states[Object.keys(label.states)[0]].name }
            var format = store.getters['printer/getFormat'](label.states[selectedState.id].format)

            self.data = []
            self.processTypes = []
            self.currentStep = 0

            self.processTypes.push('state')
            self.data.push({
                tags: label.states,
                title: i18n.t('label.popup.process.state'),
                message: i18n.t('label.popup.process.state_msg'),
                result: selectedState ? selectedState.name : '',
                selected: selectedState ? selectedState.id : '',
                keyname: 'state'
            })

            if (format && format.fields) {
                for (var i in format.fields) {
                    var step = format.fields[i]
                    self.processTypes.push(step.type)
                    if (step.type == 'date') {
                        var maxDate = undefined

                        // if(self.data[0].selected != '' && self.processTypes[0] == 'state'){
                        //   maxDate = moment().add(label.states[self.data[0].selected].time, 'minutes').format('D/M/YYYY');
                        // }
                        self.data.push({
                            title: step.name,
                            result: '',
                            input: {},
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional,
                            minDate: moment().format('DD/MM/YYYY'),
                            maxDate: maxDate
                        })
                    } else if (step.type == 'datetime') {
                        var maxDate = undefined

                        self.data.push({
                            title: step.name,
                            result: '',
                            date: {},
                            time: '',
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional,
                            minDate: moment().format('DD/MM/YYYY'),
                            maxDate: maxDate
                        })
                    } else {
                        self.data.push({
                            title: step.name,
                            result: '',
                            keyname: step.keyname,
                            type: step.type,
                            optional: step.optional
                        })
                    }
                }
            }
            self.processTypes.push('quantity')
            self.data.push({
                title: i18n.t('label.popup.process.quantity'),
                result: '',
                max: 100,
                message: i18n.t('label.popup.process.quantity_msg'),
                keyname: 'quantity'
            })

            if (Object.keys(label.states).length <= 1) {
                self.currentStep++
            }
            // for (var o in self.data) {
            //   var dt = self.data[o];
            //
            //   if (dt.result != "" && o == 0) {
            //     self.currentStep++;
            //   } else if (dt.result != "" && self.data[o - 1].result != "") {
            //     self.currentStep++;
            //   }
            // }

            self.processData.selectedState = selectedState
        },

        setProcessResult(pType, i, result) {
            this.processBeforeChanges(pType, i, result)

            if (pType == 'state') {
                this.processData.selectedState.name = result.name
                this.processData.selectedState.id = result.id
                // this.data[i].result = result.name;
                // this.data[i].selected = result.id;

                this.generateProcess()
                // Calculo de maxDate en funcion de estado
                // var datePos = this.processTypes.indexOf('date');
                // this.data[datePos].maxDate = moment().add(this.data[i].tags[result.id].time, 'minutes').format('D/M/YYYY');
            } else if (pType == 'date') {
                this.data[i].result = result.selectedDate
            } else if (pType == 'datetime') {
                let date = Object.keys(this.data[i].date).length > 0 ? this.data[i].date.selectedDate : ''
                let time = this.data[i].time ? this.data[i].time : ''

                this.data[i].result = date + ' ' + time
            } else {
                this.data[i].result = result
            }

            this.processAfterChanges(pType, i, result)
        },
        setProcessValue(pType, i, result) {
            this.processBeforeChanges(pType, i, result)

            this.data[i].result = result

            this.processAfterChanges(pType, i, result)
        },

        processBeforeChanges(pType, i, result) {
            var hasResult = this.data[i].optional || (this.data[i].result && this.data[i].result != null && this.data[i].result != '')

            if (hasResult && this.data[i].result != result) {
                for (var k = i; k < this.data.length; k++) {
                    var datos = this.data[k]
                    datos.result = ''
                    if (this.processTypes[k] == 'date') {
                        // datos.input = {};
                    } else if (this.processTypes[k] == 'datetime') {
                        // datos.input = {};
                    }
                }
            }
        },
        processAfterChanges(pType, i, result) {
            if (pType != 'date' && pType != 'datetime' && pType != 'number' && pType != 'state') {
                if (this.currentStep + 1 < this.data.length) {
                    this.currentStep++
                }
            }
        },

        changeStep(goTo) {
            let item = this.data[this.currentStep]
            let result = item.result
            let validResult = item.optional || (result && result != null && result != '')
            let isNext = this.currentStep + 1 == goTo

            if (item.type == 'datetime') {
                validResult = item.optional || (result && result != null && result != '' && item.date && Object.keys(item.date).length > 0 && item.time && item.time != null && item.time != '')
            }

            if (this.currentStep != goTo && goTo >= 0 && ((this.currentStep < goTo && validResult && isNext) || this.currentStep > goTo)) {
                this.currentStep = goTo
            }
        },

        // Funciones propias date range
        setRangeResult(result) {
            // this.inputVal = result.selectedDate;
        },

        searchBarInput(e) {
            const self = this
            if (this.timerSearch) {
                clearTimeout(this.timerSearch)
                this.timerSearch = null
            }
            this.timerSearch = setTimeout(() => {
                self.search = e.target.value
            }, 800)
        },
        cleanSearch() {
            this.search = ''
        },
        imgDelete() {
            this.callDelete(this, store)
        },
        imgEdit() {
            // console.warn('imgEdit', this)
            this.callEdit(this, store)
        },

        // to sort employeesList
        compareNames(a, b) {
            const nameA = a.name
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')

            const nameB = b.name
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')

            if (nameA < nameB) {
                return -1
            }
            if (nameA > nameB) {
                return 1
            }

            return 0
        },
        timeoutAction() {
            let self = this
            self.timeout.action.callAction()
            router.push(self.redirectPath(self.timeout.action.url))
            self.callCancel()
        }
    },
    watch: {},
    created() {
        // KEYBOARD ACTIONS HANDLER
        const escapeHandler = (e) => {
            if (e.key === 'Escape' && this.show) {
                this.cancel()
            }
        }
        const enterHandler = (e) => {
            if (e.key === 'Enter' && this.show && !this.phuSaveDisabled) {
                // Popup de creación de Incidencias (select + cType 4): el CTA "Crear sin acceder"
                // está oculto y el único CTA de guardado es "Crear y empezar". En este popup
                // save() solo crea la incidencia (callSave) pero no navega ni cierra el loading,
                // por lo que Enter debe ejecutar exactamente el mismo flujo que "Crear y empezar"
                // (saveStart -> callSaveStart, que guarda y navega al detalle creado).
                if (this.type == 'select' && this.cType == TYPE.ISSUE) {
                    const target = e.target
                    const tag = target ? target.tagName : ''
                    const isTyping = ['INPUT', 'TEXTAREA', 'SELECT'].includes(tag) || (target && target.isContentEditable)
                    // Si el foco está en un botón, se deja que el navegador ejecute su click
                    // natural (mismo comportamiento que hacer click en el CTA).
                    if (!isTyping && tag != 'BUTTON' && this.selectedEl !== undefined) {
                        this.saveStart()
                    }
                } else {
                    this.save()
                }
            }
        }

        document.addEventListener('keydown', escapeHandler)
        document.addEventListener('keydown', enterHandler)

        this.$once('hook:destroyed', () => {
            document.removeEventListener('keydown', escapeHandler)
            document.removeEventListener('keydown', enterHandler)
        })
    },
    mounted() {
        this.columnHeaders = this.$data.headers
        if (this.type == 'process') {
            this.generateProcess()
        }

        if (this.type == 'postpone') {
            if (Object.values(this.list).length == 1) {
                this.selected = '0'
                this.data.showReason = true
            }
            // AUTO SELECT DATE FIRST TIME
            this.$nextTick(function () {
                var aDays = document.querySelectorAll('.vfc-day :not( .vfc-disabled ) ')
                var selectedDay = this.data && this.data.selectedDate && this.data.selectedDate.selectedDate ? this.data.selectedDate.selectedDate.split('-')[2] : false

                if (selectedDay) {
                    for (var day in aDays) {
                        if (aDays[day].innerText == selectedDay) {
                            aDays[day].click()
                            break
                        }
                    }
                }
            })
        }

        if (this.type == 'select' && this.list && Object.keys(this.list).length > 0) {
            this.selectMe(this.list[Object.keys(this.list)[0]].id)
        }

        if (Array.isArray(this.list)) {
            this.list = this.list.sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }))
        } else if (this.list && typeof this.list === 'object') {
            this.list = Object.values(this.list).sort((a, b) => a.name.localeCompare(b.name, 'es', { sensitivity: 'base' }))
        } else {
            this.list = []
        }

        if (this.type === 'textInputLandscape') {
            this.initLandscapeTextPopup()
        }
    },
    beforeDestroy() {
        if (this.type === 'textInputLandscape') {
            this.cleanupLandscapeTextPopup()
        }
    },
    directives: {
        focus: {
            bind: function (el, binding) {
                el.focus()
            },
            componentUpdated: function (el, binding) {
                if (binding.value) {
                    el.focus()
                }
            }
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
// .v-picker--date {
//     .v-picker__title {
//         background-color: $main-t90;

//         .v-date-picker-title__year {
//             @include font-size(20);
//         }
//         .v-date-picker-title__date {
//             div {
//                 @include font-size(26);
//                 color: $main-s60;
//                 font-family: $text;
//             }
//         }
//     }

//     .v-picker__body {
//         .v-date-picker-header .accent--text {
//             text-align: center;

//             button {
//                 color: $main-dark !important;
//                 background-color: #fff;

//                 &:hover {
//                     background-color: $main-dark !important;
//                     color: #fff !important;
//                 }
//             }
//         }
//     }

//     .v-date-picker-years {
//         li {
//             text-align: center;
//         }
//     }

//     .v-btn .v-btn__content {
//         font-family: $text-light;
//     }
//     .v-btn--active {
//         background-color: $main !important;
//         .v-btn__content {
//             font-family: $text;
//         }
//     }
//     .v-btn--outline {
//         border-color: #aaa !important;
//     }
//     button {
//         &:hover {
//             background-color: $main !important;
//             color: #fff !important;
//         }
//     }
// }

.popup-container {
    @include display-flex();
    @include align-items();
    @include justify-content();
    background-color: rgba(0, 0, 0, 0.5);
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: $z-popups-unblocking;
    max-width: calc(100%);
    max-height: calc(100%);
    width: calc(100%);
    height: calc(100%);
    // top: $menu-top-height;
    // z-index: $z-popups-default;
    // max-width: calc(100% - #{$menu-tools-min});
    // max-height: calc(100% - #{$menu-top-height});
    // width: calc(100% - #{$menu-tools-min});
    // height: calc(100% - #{$menu-top-height});

    &.blocking {
        z-index: $z-overlay-blocking + 2;
    }

    /* QR identificador solo en vista no móvil ($mq !== portrait): en portrait se usan estilos media por defecto */
    &.popup-qr-identifier:not(.portrait) {
        @include justify-content(center);
        @include align-items(center);

        .popup.media {
            width: auto !important;
            min-width: 540px;
            max-width: #{'min(98vw, 700px)'};
            max-height: #{'min(94vh, 740px)'};
            height: fit-content !important;
            min-height: 0 !important;
            gap: 0 !important;
            padding: 0 !important;
            margin: 0 !important;
            box-sizing: border-box;
            align-self: center !important;
            flex-grow: 0 !important;
            flex-shrink: 0 !important;
            @include justify-content(flex-start);
            @include align-items(stretch);

            .pop-body {
                flex: 0 0 auto !important;
                width: 100% !important;
                min-width: 540px !important;
                max-width: #{'min(98vw, 700px)'};
                height: auto !important;
                max-height: none !important;
                padding: 8px 20px 0 !important;
                margin: 0 !important;
            }

            .pop-footer {
                flex: 0 0 auto !important;
                margin: 0 !important;
                padding: 12px 20px 16px !important;

                .buttons {
                    gap: 0 !important;
                    width: 100%;
                    margin: 0 !important;
                    padding: 0 !important;

                    button {
                        padding: 0.55em 0.85em !important;
                        margin: 0 !important;
                    }
                }
            }

            .kind-of.preview {
                margin: 0 !important;
                padding: 40px 28px 20px !important;
                width: 100% !important;
                min-width: 0;
                max-width: none;
                height: auto !important;
                min-height: unset !important;
                box-sizing: border-box;
                overflow: visible !important;

                > div {
                    width: 100% !important;
                    height: auto !important;
                    min-height: unset !important;
                    max-height: none !important;
                    margin: 0 !important;
                    padding: 0 !important;
                    display: flex !important;
                    align-items: center;
                    justify-content: center;
                }

                .preview-media-img {
                    display: block;
                    width: 180px !important;
                    height: 180px !important;
                    max-width: 180px !important;
                    max-height: 180px !important;
                    flex-shrink: 0 !important;
                    aspect-ratio: 1;
                    margin: 0 !important;
                    padding: 0 !important;
                    object-fit: contain;
                }

                .popup-media-caption {
                    margin: 28px 12px 32px !important;
                    padding: 0 !important;
                    font-size: 15px;
                    line-height: 1.35;
                    letter-spacing: normal;
                    word-break: break-all;
                    max-width: 100%;
                    box-sizing: border-box;
                }
            }
        }
    }

    // &:not(.blocking) {
    //     // top: $menu-top-height;
    //     // max-height: calc(100% - #{$menu-top-height});
    // }
    .popup {
        &.message {
            border-top: 10px solid $color-primary-500;
            .pop-body {
                padding-top: 4px;
                .kind-of {
                    .message {
                        background: none;
                    }
                }
            }
        }
    }

    &.pls-stock-popup {
        .popup {
            &.numericNewDesing {
                max-width: 500px;
            }
            &.messageNewDesing {
                .pop-header {
                    background-color: $color-error-600;
                }

                .pop-body {
                    .kind-of {
                        .content {
                            p {
                                font-family: $text-bold;
                                @include font-size(24px);
                                color: $color-neutral-800;
                                line-height: normal;
                                text-align: left;
                            }
                        }
                    }
                }

                .pop-footer {
                    .buttons {
                        flex-direction: row;

                        .act {
                            &.save {
                                background-color: $color-error-600;
                                color: $color-white;
                            }
                        }
                    }
                }
            }
        }
    }

    .popup {
        &.printConfig {
            padding: 0px;
            max-width: 550px;
            .pop-header {
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                @include flex-direction(row);
                background-color: $color-primary-500;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding-left: 16px;
                padding-right: 16px;
                .title {
                    @include display-flex();
                    @include align-items(center);
                    p {
                        font-family: $text-bold;
                        @include font-size(20px);
                        color: $color-white;
                    }

                    .i-andy-menu-config {
                        color: $color-white;
                    }
                }
                .i-andy-close {
                    color: $color-white;
                    cursor: pointer;
                }
            }
            .pop-body {
                margin-top: 0px;
                padding-top: 0px;
                .kind-of {
                    .content {
                        width: 97%;
                        margin: 0 auto;
                        @include display-flex();
                        @include align-items(center);
                        @include justify-content(space-between);
                        @include flex-direction(column);
                        gap: 16px;

                        .option {
                            cursor: pointer;
                            width: 100%;
                            border-radius: 4px;
                            border: 1px solid #e2e2e2;
                            padding: 8px;
                            color: #3b3b3b;
                            @include font-size(18px);
                            @include display-flex();
                            @include align-items(center);
                            @include justify-content(flex-start);
                            @include flex-direction(row);
                            gap: 16px;

                            .ball {
                                width: 16px;
                                height: 16px;
                                border-radius: 50%;
                                border: 1px solid #8a8a8a;
                            }

                            &.selected {
                                background-color: #f4f4f4;
                                border: 1px solid #e2e2e2;

                                .ball {
                                    background-color: $color-secondary-500;
                                }
                            }
                        }
                    }
                }
            }

            .pop-footer {
                width: 97%;
                margin: 0 auto;
                padding: 16px 0px;

                .buttons {
                    @include flex-direction(column);

                    .act {
                        width: 100%;
                    }
                }
            }
        }

        &.plsAddProduct {
            padding: 0px;
            max-height: 773px;
            gap: 0px;
            .pop-header {
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                @include flex-direction(row);
                background-color: $color-primary-500;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding-left: 16px;
                padding-right: 16px;
                .title {
                    @include display-flex();
                    @include align-items(center);
                    p {
                        font-family: $text-bold;
                        @include font-size(20px);
                        color: $color-white;
                    }
                }
                .i-andy-close {
                    color: $color-white;
                    cursor: pointer;
                }
            }
            .pop-body {
                padding-top: 0px;
            }
        }

        &.plsReset,
        &.plsResetConfirm {
            padding: 0px;
            max-width: 550px;
            gap: 0px;

            // Al editar una cantidad el teclado numérico se muestra al lado de la lista.
            &.editing {
                max-width: 800px;
            }

            .pop-header {
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                @include flex-direction(row);
                background-color: $color-error-600;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding-left: 16px;
                padding-right: 16px;

                .title {
                    @include display-flex();
                    @include align-items(center);

                    p {
                        font-family: $text-bold;
                        @include font-size(20px);
                        color: $color-white;
                    }
                }

                .i-andy-close {
                    color: $color-white;
                    cursor: pointer;
                }
            }

            .pop-body {
                padding-top: 0px;
            }

            .pop-footer {
                padding: 0 28px 20px 28px;
                box-sizing: border-box;

                .buttons {
                    gap: 14px;

                    .act {
                        width: 50%;
                        border: none;
                        color: $color-neutral-800;
                        background-color: $color-neutral-400;

                        &.save {
                            background-color: $color-error-600;
                            color: $color-white;
                        }
                    }
                }
            }
        }

        &.plsResetConfirm {
            .pop-body {
                .kind-of {
                    width: 100%;

                    .message {
                        width: 100%;
                        margin: 0;
                        padding: 32px 28px 40px 28px;
                        box-sizing: border-box;
                        background: none;
                        font-family: $text;
                        @include font-size(18px);
                        line-height: 1.5;
                        color: $color-neutral-800;
                        text-align: left;
                    }
                }
            }
        }

        &.plsResetLoading {
            padding: 0px;
            max-width: 520px;
            gap: 0px;

            .pop-header {
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(flex-start);
                background-color: $color-primary-500;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding: 12px 16px;

                .title {
                    @include display-flex();
                    @include align-items(center);
                    gap: 8px;

                    i {
                        color: $color-white;
                    }

                    p {
                        font-family: $text-bold;
                        @include font-size(18px);
                        color: $color-white;
                    }
                }
            }

            .pop-body {
                padding-top: 0px;

                .kind-of {
                    width: 100%;

                    .message {
                        width: 100%;
                        margin: 0;
                        padding: 24px 28px 32px 28px;
                        box-sizing: border-box;
                        background: none;
                        font-family: $text;
                        @include font-size(16px);
                        line-height: 1.4;
                        color: $color-neutral-800;
                        text-align: center;
                    }
                }
            }
        }
    }

    &.popup-small {
        .popup {
            max-width: 550px;

            .pop-body {
                min-width: 450px;
                padding: 10px;

                .title {
                    font-weight: bold;
                    margin-bottom: 10px;
                }

                .paragraph {
                    margin: 10px 0;
                }
            }
        }
    }
    &.popup-label {
        position: absolute;
        width: calc(100% - #{$menu-tools-min});
        max-width: calc(100%);
        height: calc(100% - #{$menu-top-height} - (#{$alex-app-padding} * 2));
        top: $menu-top-height + $alex-app-padding;
        left: $menu-tools-min - $alex-app-padding;
        border-radius: $default-border-radius;
        .pop-footer {
            display: none;
        }
    }

    &.auditPoints {
        .pop-body {
            .kind-of {
                display: flex !important;
                flex-direction: column !important;
                height: 200px !important;
                justify-content: flex-start !important;

                .audit-score {
                    width: 100%;
                    @include font-size(60px);
                    font-family: $text-bold;
                    color: $neutro-s80;
                    height: fit-content;
                    text-align: center;
                    height: 155px !important;
                    display: flex !important;
                    justify-content: center !important;
                    align-items: center !important;
                }
            }
        }
        .pop-footer {
            min-height: 75px !important;
        }
    }

    &.item-settings {
        .popup {
            .pop-body {
                padding-top: 8px;
            }
        }
    }

    &.popup-label-admin {
        position: absolute;
        width: calc(100% - #{$menu-tools-min});
        max-width: calc(100%);
        height: calc(100% - #{$menu-top-height} - (#{$alex-app-padding} * 2));
        top: $menu-top-height + $alex-app-padding;
        left: $menu-tools-min - $alex-app-padding;
        border-radius: $default-border-radius;
    }

    &.tablePopup {
        height: 100%;
        max-height: 100%;
        .popup {
            position: absolute;
            max-height: calc(100% - 16px);
            right: 8px;
            bottom: 8px;
            top: 8px;
            width: 400px;
            height: 100%;
            @include display-flex();
            @include justify-content(start);

            h1 {
                padding-left: 0px;
                @include font-size(24px);
            }
            .pop-body {
                flex-direction: column;
                height: 100%;
                width: 100%;
                @include justify-content(start);

                .kind-of.check-container {
                    overflow-x: hidden;
                    margin-top: 0px;
                    width: 100%;
                    @include justify-content(start);
                    .check-box-container {
                        padding-left: 30px;
                        position: relative;

                        .table-column-drag-handle {
                            position: absolute;
                            top: 0;
                            bottom: 0;
                            left: 0;
                            width: 30px;
                            background-image: img('drag_dots.svg');
                            background-repeat: no-repeat;
                            background-position: center;
                            cursor: grab;
                            touch-action: none;

                            &:active {
                                cursor: grabbing;
                            }
                        }

                        .check-box {
                            width: 328px;
                            &:hover {
                                background-color: #e2e2e2;
                            }
                        }
                    }
                    .check-title {
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        -webkit-box-orient: vertical;
                        overflow: hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
            .pop-footer {
                height: 17%;
                div.buttons {
                    flex-direction: column;
                    gap: 8px;
                    justify-content: flex-end;
                    button {
                        width: 100%;
                    }
                }
            }
        }
    }

    &.renew {
        .popup {
            border-top: 8px solid $color-warning-500;
            &.renew {
                .kind-of {
                    flex-direction: column;
                    @include align-items();
                    .title {
                        @include font-size(ml);
                        font-family: $text-bold;
                        margin-bottom: 16px;
                    }

                    .message {
                        background: transparent;
                        text-align: center;
                    }

                    &.portrait {
                        .message {
                            @include font-size(s);
                            margin-bottom: 16px;
                        }

                        .title {
                            @include font-size(sm);
                            margin-bottom: 16px;
                        }
                    }
                }
            }
        }

        .pop-footer {
            .buttons {
                display: block !important;
                width: fit-content !important;

                .act {
                    background-color: $color-secondary-500;
                }
            }
        }
    }

    &.offline {
        .popup {
            .pop-footer {
                .buttons {
                    .act.save {
                        display: none;
                    }
                }
            }
        }
    }

    .popup {
        @include display-flex();
        @include align-items();
        @include justify-content();
        @include flex-direction($dir: column);
        @include border-radius(4px);
        position: relative;
        background-color: #fff;
        max-width: 700px;
        max-height: 90%;
        width: calc(100% - 20px);
        height: auto;
        // padding: 2em;
        padding: 8px;
        gap: 1.5em;

        &.login {
            height: 574px;
            .pop-alex {
                background-size: 52.62px 48px;
                &.normal {
                    width: 64px;
                    height: 64px;
                    top: -2.1rem;
                }
            }
            .pop-body {
                overflow: hidden;
                .kind-of {
                    flex-direction: column;
                    .disabledMessage {
                        font-family: $text-bold;
                        font-size: 24px;
                    }
                    .message-info {
                        color: $main-s30;
                        font-family: $text;
                        font-size: 16px;
                        border-bottom: 0;
                    }
                    .mainContainer {
                        display: flex;
                        width: 100%;
                        height: 368px;
                    }
                    .left {
                        display: flex;
                        overflow-y: scroll;
                        max-height: 420px;
                    }
                }
            }
        }

        .pop-alex {
            @include background($size: rem(60px), $image: img('alexhead_06.svg'), $color: #fff);
            @include border-radius(100%);
            border: solid 3px $main-t80;
            width: rem(80px);
            height: rem(80px);
            display: block;
            position: absolute;
            top: rem(-55px);
            left: rem(15px);
            z-index: $z-popups-default + 1;
            //z-index: 1000;

            &.normal {
                top: -2.1rem;

                background-image: img('alex_carita_07.svg');
            }
            &.geolocation {
                background-image: img('alex_carita_10.svg');
                width: 80px;
                height: 80px;
            }
        }

        .pop-alex-lottie {
            @include border-radius(100%);
            background-color: white;
            border: solid 3px $main-t80;
            width: rem(64px);
            height: rem(64px);
            display: block;
            position: absolute;
            top: rem(-45px);
            left: rem(15px);
            z-index: $z-popups-default + 1;
            div#app {
                height: 100%;
                display: grid;
                place-content: center;
                div {
                    height: 50%;
                    margin-top: 35%;
                    display: grid;
                    place-content: center;
                    svg {
                        width: 54px !important;
                        height: 54px !important;
                    }
                }
            }
        }

        .pop-close {
            @include background($size: 20px, $image: img('close_primary.svg'), $color: $main-t30);
            width: rem(40px);
            height: rem(40px);
            display: inline-block;
            float: right;
        }

        .pop-header,
        .pop-body,
        .pop-footer {
            @include display-flex();
            @include justify-content();
            width: 100%;
            height: auto;
            overflow: auto;
            .buttons {
                .act {
                    flex: 1;
                    box-sizing: border-box;
                }
            }
        }

        .pop-header {
            @include align-items(flex-start);
            min-height: rem(40px);
            padding-left: rem(70px);
            padding-right: rem(30px);
            margin-top: -10px;

            .title-message {
                font-family: $text;
                color: $main;
                padding: 0;
                background-color: $main-t90;
                border-color: $main-t90;
                padding: 8px 16px;
                border-radius: 3px;
                position: relative;

                &:after {
                    content: '';
                    position: absolute;
                    left: 0;
                    top: 50%;
                    width: 0;
                    height: 0;
                    border: 6px solid transparent;
                    border-right-color: inherit;
                    border-left: 0;
                    // border-bottom: 0;
                    margin-top: -6px;
                    margin-left: -6px;
                }
            }
        }

        .pop-body {
            // @include flex-wrap(wrap);
            @include width-min-content();
            max-height: calc(100% - #{rem(80px)});
            height: auto;
            min-width: unset;
            // min-width: 100%;
            width: 100%;
            max-width: unset;
            overflow: auto;
            padding: 0px;
            padding-top: 23px;
            .search-container {
                input {
                    border: 1px solid $color-neutral-300;
                    background-color: #fff;
                }
                input[type='search']::placeholder {
                    @include font-size(m);
                    width: 100%;
                    min-width: 200px;
                }
            }
            .screenlock-message-kind-of {
                flex-direction: column !important;
            }
            .kind-of {
                @include display-flex();
                @include flex-direction(row);
                @include justify-content(center);
                @include align-items(flex-start);
                // max-height: calc(100% - 125px);
                height: max-content;
                min-width: 150px;
                // min-width: 100%;
                width: 100%;
                // overflow: auto;
                p.issue-name {
                    font-size: 15px;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    overflow: hidden;
                    -webkit-line-clamp: 2;
                }

                &.item-settings {
                    @include display-flex();
                    @include flex-direction(column);
                    @include justify-content(center);
                    @include align-items(center);

                    .title {
                        @include font-size(l);
                        font-family: $text-bold;
                        text-transform: uppercase;
                        margin-bottom: 16px;
                    }
                }

                .screenlock-message {
                    background-color: #f4f4f4;
                    border-radius: 4px;
                    overflow-y: scroll;
                    @media (max-width: 900px) {
                        max-height: 100%;
                    }
                }

                ul,
                ol {
                    list-style: revert;
                    padding-left: 25px;
                }

                u {
                    text-decoration: underline !important;
                }
            }

            .kind-of.check-container {
                overflow-x: hidden;
                margin-top: -1.8em;
                color: red;
                flex-direction: column;
                h1 {
                    font-size: 24px;
                    text-align: left;
                }

                div.check-box {
                    display: flex;
                    flex-direction: row;
                    width: 100%;
                    height: 51px;
                    padding: 0px 13.6px;
                    align-items: center;
                    margin-bottom: 8px;
                    flex-shrink: 0;
                    border-radius: 6.8px;
                    border: 1.7px solid var(--color-neutral-500, #e2e2e2);
                    cursor: pointer;
                    div.check-input {
                        background-color: $color-neutral-500;
                        @include background($image: img('tick_unselected.svg'), $position: center, $size: 16px);
                        border-radius: 3px;
                        display: flex;
                        width: 25px;
                        height: 25px;
                        padding: 10px 12px;
                        justify-content: center;
                        align-items: center;
                        gap: 10px;
                        flex-shrink: 0;
                        transition: background-color 0.5s;
                    }
                    .check-title {
                        margin-left: 8px;
                    }
                }

                div.check-box.activeHeader {
                    div.check-input {
                        background-color: $main-dark;
                        @include background($image: img('tick_ffffff.svg'), $position: center, $size: 16px);
                    }
                }
            }

            .left,
            .right {
                @include display-inline-flex();
                @include flex-direction($dir: column);
                @include justify-content($val: flex-start);
                @include align-items();
                width: 50%;
                // height: auto;
                height: 100%;
                overflow-x: hidden;
                overflow-y: auto;
                padding: 10px;
            }
            .full {
                @include display-inline-flex();
                @include flex-direction($dir: column);
                @include justify-content($val: flex-start);
                @include align-items();
                width: 100%;
                // height: auto;
                height: 100%;
                overflow-x: hidden;
                overflow-y: auto;
                padding: 10px;
            }

            .disabled {
                cursor: not-allowed;
                position: relative;

                > div,
                > ul {
                    &:before,
                    &:after {
                        width: calc(100%);
                        height: calc(100%);
                        position: absolute;
                        top: 0;
                        left: 0;
                    }

                    &:before {
                        @include font-size(xl);
                        line-height: 125%;
                        font-family: $conden-bold;
                        color: $main-s30;
                        content: attr(data-msg);
                        text-align: center;
                        z-index: 2;
                        padding: 45% 24px;
                    }
                    &:after {
                        background-image: linear-gradient(to bottom, rgba(255, 255, 255, 1) 15%, rgba(255, 0, 0, 0) 50%), linear-gradient(to top, rgba(255, 255, 255, 1) 15%, rgba(255, 0, 0, 0) 50%), linear-gradient(to left, rgba(255, 255, 255, 1), rgba($main-t90, 0.8), rgba(255, 255, 255, 1));
                        content: '';
                    }
                }
            }

            .message {
                @include font-size(m);
                padding: 10px 14px;
                font-family: $text-light;
                background-color: $warning-t60;
                position: relative;
                min-width: 100%;
                line-height: 25px;
                width: 100%;

                &.emailAlert {
                    text-align: center;

                    .image-preview {
                        width: 100px;
                    }
                }

                // &:after {
                //     content: '';
                //     display: block; /* reduce the damage in FF3.0 */
                //     position: absolute;
                //     top: -12px;
                //     left: 15px;
                //     width: 0;
                //     border-width: 15px 15px 0;
                //     border-style: solid;
                //     border-color: $default-bg-color transparent;
                //     transform: rotate(180deg);
                // }
            }

            .message-info {
                @include font-size(s);
                margin: 6px 0 8px 0;
                color: $main-s20;
                border-bottom: 1px solid $main-s10;
                text-align: left;
                width: 100%;
            }

            .message-error {
                @extend .message-info;
                color: $error;
                border-color: $error;
            }

            .place {
                width: 100%;
                border-bottom: 1px solid $main-t70;

                .item {
                    @include border-top-radius(3px);
                    font-family: $text;
                    display: inline;
                    float: left;
                    width: 33%;
                    padding: 10px 10px;
                    text-align: center;
                    color: $main-s50;
                }

                .item.selected {
                    background-color: $main-t90;
                }
            }

            .list {
                min-width: 150px;
                width: 100%;
                height: 100%;

                .item {
                    @include border-radius(3px);
                    @include display-flex();
                    @include align-items();
                    height: rem(40px);
                    width: 100%;
                    border-bottom: 1px solid #eee;

                    &.default {
                        // background-color: #fbfbfb;
                        border-bottom-color: $main-t30;
                    }
                    &.selected {
                        background-color: $main-t90;
                        border-bottom: 2px solid $main;
                    }

                    .user-color {
                        @include dftUserColor();
                        @include text-ellipsis();
                        width: 35px;
                        height: 35px;
                        display: inline;
                        margin: 0 5px;

                        &:after {
                            padding: 12px 0;
                        }
                    }

                    .user-name {
                        @include text-ellipsis();
                        font-family: $text;
                    }
                }

                &.select-list {
                    .item {
                        @include display-flex();
                        @include align-content(center);
                        @include interaction();
                        padding-left: 12px;
                        overflow: hidden;
                        line-height: 1.1;

                        .name {
                            @include text-ellipsis($line: 2);
                        }
                    }
                }
            }

            .toolbar {
                width: 100%;
                height: rem(40px);
                display: flex;
                justify-content: space-around;

                .btn {
                    @include font-size(s);
                    text-transform: none;
                    color: #777;
                    background-color: transparent;
                    margin: 0 6px;
                    padding: 0 6px;
                }
            }
        }

        .pop-footer {
            @include border-radius(0 0 3px 3px);
            // min-height: 125px;
            background-color: #fff;

            .buttons {
                @include display-flex();
                @include align-items(flex-end);
                @include flex-direction(row);
                gap: 1em;
                width: 100%;
                height: auto;
                text-align: right;

                button {
                    @include border-radius(4px);
                    @include font-size(m);
                    font-family: $text-bold;
                    border: 1px solid rgba(131, 131, 131, 0.03);
                    height: auto;
                    padding: 0.8em 1em;
                    // height: 54px;
                    color: $main;
                    background-color: $main-t90;
                    width: 49%;
                    overflow: hidden;
                    cursor: pointer;

                    &.full {
                        width: 100%;
                    }

                    // &:first-child {
                    //     // margin-right: 0;
                    // }

                    &:only-child {
                        width: 100%;
                    }

                    &.save {
                        @include font-size(m);
                        color: #fff;
                        background-color: $main;
                        font-family: $text-bold;
                        border: none;
                    }
                    &.logout {
                        // @include default-box-shadow();
                        // font-weight: bold;
                        float: left;
                    }

                    &.productInfo {
                        background: $color-secondary-500;
                        color: #ffffff;
                    }
                }
            }
        }

        &.quantity {
            .left {
                @include justify-content();
            }

            .message {
                margin-top: 20px;
            }

            .pin {
                @include font-size(xl);
            }

            .rem-amount {
                @include font-size(s);
                color: $error;
                margin-top: 40px;
                font-family: $text;
            }
        }

        &.offlineAlert {
            border-top: 8px solid $color-error-500;
            .pop-body {
                .kind-of {
                    .message {
                        background-color: transparent;
                        text-align: center;
                        font-weight: bold;
                    }
                }
            }
            .pop-footer {
                .buttons {
                    .act.save {
                        display: block;
                    }
                }
            }
        }

        &.media,
        &.previewSignature {
            @include justify-content($val: flex-end);
            max-width: 95%;
            max-height: 90%;

            .pop-body {
                height: auto;
                min-width: unset;
                width: 100%;
                max-width: 100%;
                overflow: auto;
                text-align: center;
            }
            .kind-of {
                width: unset;
                min-width: unset;
                height: unset;
                &.preview {
                    margin: 10px;
                    overflow: auto;
                    text-align: center;
                    width: 100%;
                    min-height: 0;
                    max-height: calc(100vh - 180px);
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    div {
                        width: 100%;
                        height: auto;
                        min-height: 0;
                        max-height: inherit;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    .preview-media-img {
                        display: block;
                        object-fit: contain;
                        width: auto;
                        height: auto;
                        max-width: 100%;
                        max-height: calc(100vh - 220px);
                        margin: 0 auto;
                    }
                    .popup-media-caption {
                        margin: 12px 0 0;
                        color: var(--color-black, #222);
                        text-align: center;
                        font-family: $text;
                        font-size: 24px;
                        font-style: normal;
                        font-weight: 400;
                        line-height: normal;
                        letter-spacing: -0.72px;
                        word-break: break-all;
                    }
                }
            }
        }

        &.previewSignature {
            max-width: 90%;
        }

        &.select {
            gap: 12px;
            .pop-body {
                overflow: hidden;
                .full {
                    padding: 10px 0px 0px 0px;
                }
                .kind-of {
                    display: inline;
                }
            }

            .list {
                overflow: auto;
                height: 300px;
                padding-right: 6px;
                .item {
                    border: 1px solid $color-neutral-300;
                    margin-bottom: 12px;
                    overflow: hidden;
                    margin-right: 0px;
                }
                .item.default {
                    border-bottom-color: $color-neutral-300;
                }
                .item.selected {
                    border: 1.7px solid $color-neutral-300;
                }
                .item:last-child {
                    margin-bottom: 0px;
                }
            }
        }

        &.select-double {
            .pop-body {
                padding: 10px;
            }

            .list {
                .item {
                    padding: 0 8px;
                }
            }
        }
        &.messageNewDesing {
            padding: 0px;
            max-width: 550px;
            .pop-header {
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                @include flex-direction(row);
                background-color: $color-primary-500;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding-left: 16px;
                padding-right: 16px;
                .title {
                    @include display-flex();
                    @include align-items(center);
                    p {
                        font-family: $text-bold;
                        @include font-size(20px);
                        color: $color-white;
                    }

                    .i-andy-menu-config {
                        color: $color-white;
                    }
                }
                .i-andy-close {
                    color: $color-white;
                    cursor: pointer;
                }
            }
            .pop-body {
                margin-top: 0px;
                padding-top: 0px;
                .kind-of {
                    .content {
                        width: 90%;
                        margin: 0 auto;
                        @include display-flex();
                        @include align-items(center);

                        p {
                            font-family: $text;
                            @include font-size(16px);
                            color: $color-black;
                            text-align: center;
                            white-space: pre-line;
                        }
                    }
                }
            }

            .pop-footer {
                width: 97%;
                margin: 0 auto;
                padding: 16px 0px;

                .buttons {
                    @include flex-direction(column);
                    gap: 8px;

                    .act {
                        width: 100%;
                        color: $color-black;
                        background-color: $color-neutral-300;
                    }

                    .act.save {
                        order: 1;
                    }

                    .act.cancel {
                        order: 2;
                    }
                }
            }
        }

        &.numericNewDesing {
            padding: 0px;
            max-width: 400px;
            .pop-header {
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                @include flex-direction(row);
                background-color: $color-primary-500;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding-left: 16px;
                padding-right: 16px;
                .title {
                    @include display-flex();
                    @include align-items(center);
                    p {
                        font-family: $text-bold;
                        @include font-size(20px);
                        color: $color-white;
                    }

                    .i-andy-menu-config {
                        color: $color-white;
                    }
                }
                .i-andy-close {
                    color: $color-white;
                    cursor: pointer;
                }
            }

            .pop-body {
                margin-top: 0px;
                padding-top: 0px;
                .kind-of {
                    .content {
                        width: 90%;
                        margin: 0 auto;
                        @include display-flex();
                        @include flex-direction(column);
                        @include align-items(center);
                        gap: 8px;

                        .product-info {
                            @include display-flex();
                            @include align-items(center);
                            @include justify-content(center);
                            gap: 8px;
                            img {
                                width: 32px;
                                height: 32px;
                            }
                            p {
                                font-family: $text-bold;
                                @include font-size(24px);
                                color: $color-black;
                                text-align: center;
                                background-color: transparent;
                            }
                        }

                        .product-message {
                            @include font-size(20px);
                            font-family: $text;
                            color: $color-black;
                            text-align: center;
                        }

                        .message {
                            font-family: $text-bold;
                            text-transform: uppercase;
                            @include font-size(24px);
                            color: $color-black;
                            text-align: center;
                            background-color: transparent;
                        }

                        .footer {
                            padding: 48px 0;
                            @include display-flex();
                            @include align-items(center);
                            @include justify-content(center);
                            gap: 8px;
                            .remove-recommendation {
                                font-family: $text-bold;
                                padding: 4px;
                                @include font-size(16px);
                                color: $color-error-600;
                                text-align: center;
                                cursor: pointer;
                            }
                        }
                    }
                }
            }
        }

        &.numeric,
        &.numericNewDesing {
            .pop-body {
                @include flex-wrap(wrap);
                min-width: auto;
                // position: relative;
                overflow: auto;

                .kind-of {
                    @include flex-direction(column);
                    @include justify-content(flex-start);
                    @include align-items();
                    min-width: 250px;
                    text-align: center;
                    padding-bottom: 10px;
                }
            }

            // .rem-amount {
            //     @include font-size(s);
            //     color: $error;
            //     font-family: $text;
            //     margin: 12px 0;
            //     width: 100%;
            // }
        }

        &.temperature {
            .pop-body {
                @include flex-wrap(wrap);
                min-width: auto;
                overflow: auto;

                .kind-of {
                    @include flex-direction(row);
                    @include flex-wrap(wrap);
                    @include justify-content(center);
                    @include align-items();
                    min-width: 250px;
                    text-align: center;
                    padding: 0;
                }
            }
        }

        &.list_audits {
            gap: 12px;
            .pop-body {
                overflow: hidden;
                .full {
                    padding: 10px 0px 0px 0px;
                }
                .list {
                    overflow: auto;
                    height: 305px;
                    padding-right: 6px;
                    .item {
                        line-height: 1.1;
                        border: 1px solid $color-neutral-300;
                        margin-bottom: 12px;
                        overflow: hidden;
                        margin-right: 0px;

                        .audit {
                            display: -webkit-box;
                            -webkit-box-orient: vertical;
                            -webkit-line-clamp: 2;
                            text-overflow: clip;
                            overflow: hidden;
                            height: auto;
                        }
                    }
                    .item.selected {
                        border: 1.7px solid $color-neutral-300;
                    }
                    .item:last-child {
                        margin-bottom: 0px;
                    }
                }
            }
        }

        &.ticket {
            width: 90%;
            max-width: 1200px;

            .pop-body {
                @include flex-wrap(wrap);
                min-width: auto;
                overflow: auto;
                width: 100%;
                height: auto;

                .kind-of {
                    @include flex-direction(row);
                    @include flex-wrap(wrap);
                    @include justify-content(center);
                    @include align-items();
                    min-width: 250px;
                    text-align: center;
                    padding: 0;
                }
            }
        }

        &.library {
            .pop-body {
                width: auto;

                .kind-of {
                    @include flex-direction(column);
                    @include align-items();
                    overflow: auto;

                    .container-preview {
                        height: 70%;
                    }
                }
            }
        }

        &.date,
        &.dateRange {
            width: 100%;
            max-width: 750px;
            max-height: 500px;
            .kind-of {
                padding: 0px;
            }
            .pop-body {
                width: 100%;
                height: 300px;

                .kind-of {
                    width: 100%;
                    height: 100%;
                    @include display-flex();
                    gap: 20px;
                }
            }
            .pop-footer {
                max-height: 77px;
                min-height: 77px;
            }
        }

        &.input {
            .pop-body {
                margin: 12px 0;
                padding: 0 12px;

                .kind-of {
                    @include flex-direction(column);

                    input {
                        width: 100%;
                    }

                    .message-error {
                        @include width-fit-content();
                    }
                }
            }
        }

        &.sign,
        &.freeSign {
            .pop-footer .act.save:disabled {
                opacity: 0.5;
                cursor: not-allowed;
            }
        }

        &.sign {
            gap: 0.5em;

            .pop-body {
                // min-width: 700px;
                // width: auto;

                .disabled > div:before {
                    max-width: 100%;
                    max-height: 100%;
                    padding: 0 !important;
                    display: grid;
                    place-items: center;
                    font-size: 1.3em !important;
                }

                .right {
                    //   width: calc(60% + 50px);
                    padding: 0;

                    .toolbar {
                        @include display-flex();
                        @include justify-content(space-around);

                        button {
                            max-width: 50% !important;
                            width: fit-content;
                        }
                    }
                }
                .left {
                    //   width: calc(40% - 50px);
                    max-height: 50vh;

                    .users-list {
                        height: 100%;
                        overflow: auto;
                    }
                }

                .signature {
                    border-top: 2px dashed #ddd;
                    border-bottom: 2px dashed #ddd;
                    padding: 3px 0;
                    background-color: white;
                }
            }
        }

        &.freeSign {
            .pop-body {
                min-width: 300px;

                .kind-of {
                    @include flex-direction(column);
                    width: auto;
                    overflow: hidden;
                }
                .signature {
                    border-top: 2px dashed #ddd;
                    border-bottom: 2px dashed #ddd;
                    padding: 3px 0;
                    overflow: hidden;
                }
            }
        }

        &.issueAlert {
            padding: 0px;
            max-width: 550px;
            gap: 0;

            .pop-header {
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                @include flex-direction(row);
                background-color: $color-primary-500;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding: 16px;
                padding-left: 16px !important;
                padding-right: 16px !important;
                position: relative;

                .title {
                    @include display-flex();
                    @include align-items(center);

                    p {
                        font-family: $text-bold;
                        @include font-size(20px);
                        color: $color-white;
                    }
                }

                .i-andy-close {
                    color: $color-white;
                    cursor: pointer;
                }
            }

            .pop-body {
                margin-top: 0px;
                padding: 16px 24px 8px;
                @include flex-direction(column);

                .kind-of {
                    @include flex-direction(column);
                    @include align-items(center);
                    width: 100%;
                    gap: 16px;

                    .alert-message {
                        width: 100%;
                        max-height: 300px;
                        overflow: auto;
                        text-align: center;
                        font-size: 16px;
                        padding: 12px 16px;
                        box-sizing: border-box;
                    }

                    .message {
                        text-align: center;
                        font-size: 16px;
                        background-color: inherit !important;
                        width: 100%;
                        margin: 0;
                    }
                }
            }

            .pop-footer {
                width: 97%;
                margin: 0 auto;
                padding: 16px 0px;

                .buttons {
                    @include flex-direction(column);
                    gap: 8px;

                    .act {
                        width: 100%;
                    }

                    .act.save {
                        order: 1;
                        color: $color-white;
                        background-color: $color-secondary-500;
                        font-family: $text-bold;
                    }

                    .act.cancel {
                        order: 2;
                        color: $color-black;
                        background-color: $color-neutral-300;
                    }
                }
            }
        }

        &.alert {
            gap: 0px !important;

            .pop-body {
                padding: 20px 0;
            }

            .message {
                ol,
                ul {
                    padding-left: 30px;
                    list-style: disc;
                }
            }
        }

        &.process {
            height: 100%;
            min-width: 60%;

            .pop-header {
                margin-top: -15px;
            }

            .pop-body {
                height: 100%;
                width: 100%;

                .kind-of {
                    @include flex-wrap(wrap);
                    height: 100%;
                    width: 100%;
                    max-height: unset;
                }
            }

            .pop-footer {
                .buttons {
                    button {
                        margin: 4px 6px 0px 6px;

                        &.inactive {
                            // background-color: red;
                            opacity: 0.3;
                        }
                    }
                }
            }

            .product-info {
                width: 100%;
                height: 25px;
                position: relative;

                .product-title {
                    @include font-size(ml);
                    font-family: $text;
                    // color: shade($accent, 50%);
                    padding-left: calc(200px - 24px);
                    display: inline-block;
                    position: absolute;
                    width: 100%;
                    background-color: $accent-dark;
                }
            }
            .resume {
                width: 200px;
                height: calc(100% - 25px);
                overflow: auto;
                padding-right: 24px;

                .resume-step {
                    height: 25%;
                    padding: 0px 12px 24px 12px;
                    border-right: 2px solid #ccc;
                    &:first-of-type {
                        margin-top: 24px;
                    }
                    &:last-of-type {
                        padding: 0px 12px 0 12px;
                        border-color: transparent !important;
                        height: calc(25% - 24px);
                    }

                    .title {
                        @include font-size(m);
                        font-family: $text;
                        text-align: right;
                        color: #777;
                        margin: 0;
                        padding: 0;
                        position: relative;
                        transition-duration: 0.1s;

                        &:after {
                            @include border-radius(50%);
                            @include background($color: #ccc);
                            content: '';
                            width: 18px;
                            height: 18px;
                            border: 2px solid #fff;
                            position: absolute;
                            top: 0;
                            right: -22px;
                            transition-duration: 0.1s;
                        }
                    }
                    .subtitle {
                        display: block;
                        width: 100%;
                        color: #777;
                        text-align: right;
                    }

                    &.current {
                        // border-color: $accent-dark;
                        .title {
                            @include font-size(ml);

                            &:after {
                                border: none;
                                background-color: $accent-dark;
                            }
                        }
                    }
                    &.done {
                        border-color: $main;
                        .title {
                            color: $main-text;
                            &:after {
                                background-color: $main;
                            }
                        }
                    }
                }
            }
            .content {
                width: calc(100% - 200px);
                height: calc(100% - 25px);
                overflow: hidden;
                padding: 24px 24px 24px 0px;

                .step {
                    display: none;
                    overflow: auto;
                    width: 100%;
                    height: 100%;
                    min-height: 300px;
                }
                .step.current {
                    display: block;
                }

                .step-message {
                    @include font-size(sm);
                    color: #666;
                    text-align: center;
                    margin-top: 0;
                }
            }

            .tags {
                @include display-flex();
                @include flex-direction(column);
                @include flex-wrap(wrap);
                height: 100%;
                width: 100%;
                padding-left: 24px;

                .tag {
                    @include border-radius(3px);
                    @include text-ellipsis();
                    @include width-fit-content();
                    @include font-size(ml);
                    text-align: center;
                    height: 50px;
                    margin: 12px 6px;
                    padding: 15px;
                    display: inline-block;
                    background-color: #eee;
                    cursor: pointer;
                    transition-duration: 0.2s;

                    &.selected {
                        background-color: $accent-t40;
                    }
                }
            }

            // .fcalendar-container {
            // }

            .fcalendar-container.p-datetime {
                .calendar,
                .time {
                    display: inline-block;
                    width: auto;
                }
                .calendar {
                    display: inline-block;
                    min-width: 300px;

                    .vfc-main-container {
                        max-width: 300px;
                    }
                }
                .time {
                    display: inline-block;
                    min-width: 150px;
                    text-align: center;

                    .message {
                        @include font-size(sm);
                        color: $main;
                        font-family: $text-bold;
                        text-align: center;
                        display: block;
                        width: 100%;
                    }

                    input {
                        @include border-radius($default-border-radius);
                        @include font-size(m);
                        color: $main;
                        font-family: $text-bold;
                        text-align: center;
                        height: 40px;
                        padding: 0 6px 0 12px;
                        background-color: $main-t80;
                        border: none;
                        display: inline-block;
                    }
                }
            }

            .input-number {
                @include display-flex();
                @include flex-direction(column);
                @include align-items();
            }

            .input-text {
                @include background($image: img('keyboard_aaaaaa.svg'), $size: 24px, $position: left 6px center);
                padding: 12px 42px;
                width: 80%;
                margin: 0 auto;

                input {
                    @include border-radius(3px);
                    @include font-size(m);
                    font-family: $text;
                    text-align: center;
                    border: 2px solid $accent-dark;
                    background-color: $accent-t90;
                    width: 100%;
                    height: 50px;
                }
            }
        }

        &.postpone {
            .kind-of {
                padding: 0;

                .postpone-info {
                    @include display-flex();
                    @include justify-content();
                    @include flex-wrap(wrap);
                    // width: calc(600px + (10px * 4));
                    width: 100%;

                    .title-date {
                        @include font-size(ml);
                        font-family: $text;
                        width: 100%;
                        text-align: center;
                        margin-bottom: 12px;
                    }

                    .step {
                        width: 300px;
                        margin: 0 10px;
                        display: inline-block;
                    }
                    .step-date {
                        height: 340px;
                    }

                    .title {
                        @include font-size($size: sm, $important: true);
                        margin: 12px 0 6px 0;
                    }
                    .error {
                        @include font-size($size: sm, $important: true);
                        font-family: $text;
                        color: $error;
                    }

                    .datepicker {
                        width: 200px;
                        border: none;
                        box-shadow: none;

                        .v-picker__title {
                            display: none;
                        }

                        .v-picker__body {
                            margin: 0;
                        }
                    }

                    .reasons {
                        @include display-flex();
                        @include flex-wrap(wrap);
                        @include flex-direction(column-reverse);

                        .item {
                            @include border-radius($default-border-radius);
                            font-family: $text;
                            min-height: 40px;
                            width: 100%;
                            background-color: #f3f3f3;
                            margin: 6px;
                            padding: 12px;

                            &.selected {
                                background-color: $accent-t50;
                            }
                        }
                    }

                    .reason_message {
                        width: 100%;
                    }
                }

                .postpone-error {
                    width: 100%;
                    color: #222;
                    text-align: center;
                }
            }

            .pop-footer {
                min-height: 97px;
                .buttons {
                    height: 97px;
                }
            }
        }

        &.justify {
            .kind-of {
                padding: 6px 12px;

                .justify-info {
                    @include display-flex();
                    @include flex-wrap(wrap);
                    @include justify-content();
                    width: calc(600px + (10px * 4));

                    .step {
                        width: 300px;
                        margin: 0 10px;
                        display: inline-block;
                    }

                    .title {
                        @include font-size($size: sm, $important: true);
                        margin: 12px 0 6px 0;
                    }
                    .error {
                        @include font-size($size: sm, $important: true);
                        font-family: $text;
                        color: $error;
                        width: 100%;
                        text-align: center;

                        p {
                            color: $error;
                        }
                    }

                    .reasons {
                        @include display-flex();
                        @include flex-wrap(wrap);
                        @include flex-direction(column-reverse);

                        .item {
                            @include border-radius($default-border-radius);
                            font-family: $text;
                            min-height: 40px;
                            width: 100%;
                            background-color: #f3f3f3;
                            margin: 6px;
                            padding: 12px;

                            &.selected {
                                background-color: $accent-t50;
                            }
                        }
                    }

                    .reason_message {
                        width: 100%;
                        min-height: 160px;
                    }
                }

                .justify-error {
                    width: 100%;
                    color: #222;
                    text-align: center;
                }
            }
        }

        &.dateTime {
            .pop-body {
                min-width: 300px;
            }
        }

        &.disconnect {
            .pop-header {
                .title-message {
                    background-color: $error-t80;
                    color: $inactive-s90;

                    &::after {
                        border-right-color: $error-t80;
                    }
                }
            }

            .pop-body {
                @include flex-direction(column);
                margin-top: 15px;
                margin-bottom: 9px;

                &::before {
                    @include background($image: img('andy_local_logout.svg'));
                    content: '';
                    display: block;
                    width: 100%;
                    min-height: 150px;
                    margin-bottom: 12px;
                }

                .message {
                    @include font-size(m);
                }
            }

            .pop-footer {
                .act {
                    background-color: $error-t80;
                    color: $inactive-s90;
                    font-family: $text-bold;

                    &.save {
                        background-color: $error;
                        font-family: $text-bold;
                    }
                }
            }
        }

        &.delete {
            .pop-header {
                .title-message {
                    background-color: $error-t80;
                    color: $inactive-s90;

                    &::after {
                        border-right-color: $error-t80;
                    }
                }
            }

            .pop-body {
                @include flex-direction(column);
                margin-bottom: 9px;

                .message {
                    @include font-size(m);
                }
            }

            .pop-footer {
                .act {
                    background-color: $error-t80;
                    color: $inactive-s90;
                    font-family: $text-bold;

                    &.save {
                        background-color: $error;
                        font-family: $text-bold;
                    }
                }
            }
        }

        &.geolocation {
            @include border-radius(8px);

            .pop-header {
                .title-message {
                    @include border-radius(8px);
                    @include align-self(center);
                    @include justify-content(center);
                    width: 400px;
                    margin-left: 25px;

                    &:after {
                        content: '';
                        @include border-radius(8px);
                        position: absolute;
                        left: 0;
                        top: 0;
                        width: 0;
                        height: 0;
                        border: 6px solid transparent;
                        border-right-color: inherit;
                        border-left: 0;
                        // border-bottom: 0;
                        margin-top: 0px;
                        margin-left: 0px;
                    }
                }
            }

            .pop-footer {
                .buttons {
                    height: 40px;
                    margin-right: 20px;
                    margin-bottom: 20px;

                    .act {
                        @include border-radius(8px);
                        height: 40px;
                    }
                }
            }
        }

        &.resource {
            @include border-radius(8px);
            width: fit-content;
            max-width: 80% !important;

            @media (min-width: 1024px) {
                padding: 1em;
            }

            .pop-body {
                padding: 0px !important;
                margin: 0px !important;

                .header {
                    margin-bottom: 10px;
                }
            }

            .pop-footer {
                .buttons {
                    height: 40px;
                    margin-right: 20px;
                    margin-bottom: 20px;

                    .act {
                        @include border-radius(8px);
                        height: 40px;
                    }
                }
            }
        }

        // &.confirm {
        //     @media (min-width: 768px) {
        //         padding: 1.5em 2em 2em !important;
        //     }
        // }

        &.action-plan-loss,
        &.action-plan-create,
        &.simple-confirm {
            gap: 0px;

            @media (max-width: 767px) {
                padding-top: 24px;
            }

            @media (min-width: 767px) {
                gap: 8px;
            }

            .pop-header {
                margin-top: 0px;
                padding-top: 16px;
                position: relative !important;
                padding-left: 0px;
                padding-right: 0px;

                .title {
                    font-size: 18px;
                    font-weight: bold;
                    padding: 0px !important;
                    text-align: center;
                }
            }

            .pop-body {
                padding-top: 0px !important;
                margin-top: 0px !important;
            }

            .message {
                text-align: center;
                font-size: 16px;
                background-color: inherit !important;

                @media (max-width: 767px) {
                    padding-bottom: 16px !important;
                }
            }
        }

        &.action-plan-create {
            .pop-header {
                padding-top: 24px !important;
            }

            .pop-body {
                padding-bottom: 8px;
            }
        }

        &.projection,
        &.projectionReturn {
            height: 300px;
            width: 614px;
            padding: 0;
            justify-content: flex-start;
            gap: 0;
            .pop-body {
                height: 222px;
                width: 100%;
                padding: 0;
                .kind-of {
                    height: 100%;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    .title {
                        display: flex;
                        flex-direction: row;
                        align-items: center;
                        background-color: $color-primary-500;
                        font-family: $text;
                        width: 100%;
                        height: 64px;
                        font-size: 28px;
                        span {
                            font-family: $text;
                            color: $color-white;
                        }
                        .icon {
                            margin-left: 20px;
                            margin-right: 10px;
                            height: 32px;
                            width: 32px;
                            background-image: url(../../../public/img/production_graphic.svg);
                            background-size: cover;
                            background-position: center;
                            background-repeat: no-repeat;
                        }
                    }
                    .text {
                        background-color: $color-neutral-200;
                        width: 568px;
                        height: 80px;
                        margin-left: 24px;
                        margin-top: 40px;
                        margin-bottom: 40px;
                        font-size: 24px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        span {
                            font-family: $text;
                            margin-bottom: 5px;
                        }
                    }
                }
            }
            .pop-footer {
                height: 84px;
                margin: 0;
                .buttons {
                    align-items: center;
                    justify-content: center;
                    .act {
                        width: 568px;
                        height: auto;
                        margin-bottom: 28px;
                        flex: 0 0 auto;
                        color: $color-black;
                        background-color: $color-neutral-300;
                        font-family: $text-bold;
                    }
                }
            }
        }

        &.productInfo {
            background-color: $default-bg-color;
            height: 60%;
            width: 30%;

            .pop-body {
                width: 100%;
                height: 100%;

                .kind-of {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: flex-start;
                    overflow: hidden;
                    .title {
                        display: block;
                        font-family: $text-bold;
                        text-transform: uppercase;
                        @include font-size(m);
                        margin-bottom: 0;
                    }

                    .subtitle {
                        display: block;
                        font-family: $text;
                        color: $color-neutral-600;
                        display: block;
                    }

                    .product {
                        width: 100%;
                        height: 20%;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        align-items: center;
                        .icon {
                            width: 40px;
                            height: 40px;
                            background-repeat: no-repeat;
                            background-position: center;
                            background-size: 90%;
                            display: inline-block;
                            margin-right: 20px;
                        }

                        .text {
                            display: flex;
                            flex-direction: column;
                        }
                    }
                    .content {
                        width: 100%;
                        height: 70%;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                        margin-top: 10%;
                        .title {
                            margin-bottom: 5px;
                        }

                        .subtitle {
                            margin-bottom: 20px;
                        }
                        .text,
                        .value {
                            display: flex;
                            flex-direction: column;
                        }
                        .text {
                            width: 65%;
                            margin-left: 5%;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            white-space: nowrap;
                        }
                        .value {
                            width: 15%;
                            margin-right: 5%;
                            align-items: center;
                        }
                    }
                }
            }
        }

        &.media {
            height: auto;
            max-height: calc(100% - 16px);
            .pop-body {
                overflow: auto;
                width: 100%;
                height: auto;
                max-height: calc(100vh - 120px);
            }
            .kind-of.preview {
                height: auto !important;
                min-height: 0;
                max-height: calc(100vh - 180px);
                justify-content: center;

                > div {
                    min-height: 0;
                    max-height: inherit;
                    align-items: center;
                }

                .preview-media-img {
                    width: auto;
                    height: auto;
                    max-width: 100%;
                    max-height: calc(100vh - 220px);
                }
            }
            .pop-footer .buttons button.save {
                background-color: $color-error-500;
            }
        }
    }

    .screenlockUserLevelOne,
    .screenlock {
        gap: 0.5em;
        max-width: 438px;
        @media (max-width: 900px) {
            max-height: 91% !important;
            height: 100% !important;
            bottom: 5% !important;
            .kind-of,
            .screenlock-message,
            .pop-body {
                max-height: 100% !important;
                height: 100% !important;
            }
            .pop-footer {
                height: 49px !important;
            }
        }
        .pop-footer {
            height: fit-content !important;
            overflow: initial;
        }
        .pop-alex {
            display: none;
        }
        .pop-body {
            padding-top: 0px !important;
            margin-top: 0px !important;
            max-height: 550px;
        }
    }

    .screenlockUserLevelOne {
        .pop-body {
            max-height: 550px;
        }
        .alert {
            padding: 0.5rem;
            border-radius: 4px;
            width: 100%;
            background-color: #dcb16d;
            display: flex;
            align-items: center;
            font-size: 18px;
            .alex {
                @include background($image: img('alexhead_06.svg'), $size: contain, $position: left top);
                width: 40px;
                height: 40px;
                display: inline-block;
                margin-right: 6px;
            }
        }

        .pop-footer {
            height: 100%;
            .buttons {
                flex-direction: column;
                gap: 0.5em;
            }
            .save {
                width: 100% !important;
                max-height: 55px;
            }
        }
    }

    &.calm {
        .pop-alex {
            background-image: img('alex_carita_02_right.svg');
        }
    }
    &.smiling {
        .pop-alex {
            background-image: img('alex_carita_03_right.svg');
        }
    }
    &.happy {
        .pop-alex {
            background-image: img('alex_carita_12.svg');
        }
    }
    &.error {
        .pop-alex {
            background-image: img('alex_carita_04.svg');
            background-color: $error-t60;
            border: solid 3px $error;
        }

        .pop-body {
            .kind-of {
                .message {
                    background-color: $error-t60 !important;
                }
            }
        }
    }
    &.warning {
        .pop-alex {
            background-image: img('alex_carita_04.svg');
        }
    }
    &.surprised,
    &.warning {
        .pop-alex {
            background-image: img('alex_carita_05.svg');
        }
    }
    &.talking,
    &.info {
        .pop-alex {
            background-image: img('alex_carita_10.svg');
        }
    }
    &.looking_up {
        .pop-alex {
            background-image: img('alex_carita_01_right.svg');
        }
    }
    &.looking_down {
        .pop-alex {
            background-image: img('alex_carita_08_right.svg');
        }
    }
}
</style>

// PORTRAIT STYLES
<style lang="scss">
.popup-container.portrait {
    @include align-items(flex-end);
    width: 100% !important;
    left: 0 !important;

    /* Modal QR identificador en móvil: solo reduce el código (el resto sigue siendo el media portrait estándar) */
    &.popup-qr-identifier {
        .popup.media .kind-of.preview .preview-media-img {
            width: #{'min(200px, 62vw)'} !important;
            height: #{'min(200px, 62vw)'} !important;
            max-width: #{'min(200px, 62vw)'} !important;
            max-height: #{'min(200px, 62vw)'} !important;
            flex-shrink: 0 !important;
            aspect-ratio: 1;
            object-fit: contain;
        }
    }

    &.email-alert {
        @include align-items(center);
    }
    &.tablePopup {
        height: 100%;
        max-height: 100%;
        .popup-container.tablePopup .popup .pop-body .kind-of.check-container .check-box-container .check-box {
            width: 287px;
        }
        .popup {
            position: fixed;
            max-height: calc(100% - 16px);
            right: auto;
            left: auto;
            width: 350px;
            height: 100%;

            .pop-body {
                height: 80%;
                overflow: visible;
                margin: 0 auto;
                padding: 0 auto;
                .kind-of.check-container .check-box-container .check-box {
                    width: 287px;
                }
                div.kind-of {
                    width: 100%;
                    margin-top: 0;
                    height: 100%;
                    overflow-x: hidden;
                    padding: 0 auto;
                    h1 {
                        padding-left: 0px;
                    }
                }
            }
            .pop-footer {
                height: 20%;
                div.buttons {
                    flex-direction: column;
                    gap: 8px;
                    justify-content: flex-end;
                    button {
                        width: 100%;
                    }
                }
            }
        }
    }

    .popup {
        &.printConfig {
            padding: 0px;
            max-width: 550px;
            bottom: 50%;
            transform: translateY(50%);
            .pop-header {
                position: initial;
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                @include flex-direction(row);
                background-color: $color-primary-500;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding-left: 16px;
                padding-right: 16px;
                .title {
                    @include display-flex();
                    @include align-items(center);
                    p {
                        font-family: $text-bold;
                        @include font-size(20px);
                        color: $color-white;
                    }

                    .i-andy-menu-config {
                        color: $color-white;
                    }
                }
                .i-andy-close {
                    color: $color-white;
                    cursor: pointer;
                }
            }
            .pop-body {
                margin-top: 0px;
                padding-top: 0px;
                .kind-of {
                    .content {
                        width: 95%;
                        margin: 0 auto;
                        @include display-flex();
                        @include align-items(center);
                        @include justify-content(space-between);
                        @include flex-direction(column);
                        gap: 16px;

                        .option {
                            cursor: pointer;
                            width: 100%;
                            border-radius: 4px;
                            border: 1px solid #e2e2e2;
                            padding: 8px;
                            color: #3b3b3b;
                            @include font-size(18px);
                            @include display-flex();
                            @include align-items(center);
                            @include justify-content(flex-start);
                            @include flex-direction(row);
                            gap: 16px;

                            .ball {
                                width: 16px;
                                height: 16px;
                                border-radius: 50%;
                                border: 1px solid #8a8a8a;
                            }

                            &.selected {
                                background-color: #f4f4f4;
                                border: 1px solid #e2e2e2;

                                .ball {
                                    background-color: $color-secondary-500;
                                }
                            }
                        }
                    }
                }
            }

            .pop-footer {
                width: 97%;
                margin: 0 auto;
                padding: 16px 0px;

                .buttons {
                    @include flex-direction(column);

                    .act {
                        width: 100%;
                    }
                }
            }
        }

        &.issueAlert {
            padding: 0px;
            max-width: 550px;
            bottom: 50%;
            transform: translateY(50%);

            .pop-header {
                position: initial;
                width: 100%;
                @include display-flex();
                @include align-items(center);
                @include justify-content(space-between);
                @include flex-direction(row);
                background-color: $color-primary-500;
                border-radius: 4px 4px 0 0;
                color: $color-white;
                margin-top: 0px;
                padding: 16px;
                padding-left: 16px !important;
                padding-right: 16px !important;

                .title {
                    @include display-flex();
                    @include align-items(center);

                    p {
                        font-family: $text-bold;
                        @include font-size(20px);
                        color: $color-white;
                    }
                }

                .i-andy-close {
                    color: $color-white;
                    cursor: pointer;
                }
            }

            .pop-body {
                margin-top: 0px;
                padding: 16px 24px 8px;
                @include flex-direction(column);

                .kind-of {
                    @include flex-direction(column);
                    @include align-items(center);
                    width: 100%;
                    height: auto;
                    gap: 16px;

                    .alert-message {
                        width: 100%;
                    }

                    .message {
                        width: 100%;
                    }
                }
            }

            .pop-footer {
                width: 97%;
                margin: 0 auto;
                padding: 16px 0px;

                .buttons {
                    @include flex-direction(column);
                    gap: 8px;

                    .act {
                        width: 100%;
                    }

                    .act.save {
                        order: 1;
                        color: $color-white;
                        background-color: $color-secondary-500;
                        font-family: $text-bold;
                    }

                    .act.cancel {
                        order: 2;
                        color: $color-black;
                        background-color: $color-neutral-300;
                    }
                }
            }
        }
    }

    .popup {
        height: fit-content;
        max-width: unset;
        bottom: 10px;

        &.alert {
            max-height: calc(100vh - 56px);

            .pop-body {
                flex: 1 1 auto;
                min-height: 0;
                overflow-y: auto;

                .kind-of {
                    height: auto;
                    min-height: 0;
                }

                .message {
                    overflow-wrap: anywhere;
                }
            }

            .pop-footer {
                flex: 0 0 auto;
                height: auto;
                overflow: visible;
            }
        }

        .pop-alex {
            @include background($size: rem(40px));
            width: rem(60px);
            height: rem(60px);
            top: rem(-35px);
        }

        .pop-alex-lottie {
            @include border-radius(100%);
            background-color: white;
            border: solid 3px $main-t80;
            width: rem(56px);
            height: rem(56px);
            display: block;
            position: absolute;
            top: rem(-35px);
            left: rem(15px);
            z-index: $z-popups-default + 1;
            div#app {
                height: 100%;
                display: grid;
                place-content: center;
                div {
                    height: 50%;
                    margin-top: 35%;
                    display: grid;
                    place-content: center;
                    svg {
                        width: 58px !important;
                        height: 58px !important;
                    }
                }
            }
        }
        .pop-header {
            @include font-size(s);
            position: absolute;
            top: -0.3rem;
            left: 0.1rem;
        }

        .pop-body {
            width: 100%;
            overflow: none;
            min-width: unset;
            background: none;
            height: fit-content;
            margin-top: 20px;
            padding-top: 16px;

            &::before {
                //@include background( $image: img('andy_local_logout.svg'), $size: 100px );
                background: none;
                width: 100% !important;
                overflow: hidden;
                //min-height: 150px;
                min-height: 0;
                min-width: 0;
            }

            .kind-of {
                // height: fit-content;
                height: calc(100% - 40px);
                // overflow: auto;

                .message {
                    @include font-size(s);
                    @include border-radius(4px);
                    padding: 8px;
                    color: black;
                    font-family: Source Sans 3;
                    font-size: 18px;
                    font-style: normal;
                    font-weight: 400;
                    line-height: normal;

                    &:after {
                        left: 25px;
                    }
                }
                &.item-settings {
                    .title {
                        @include font-size(sm);
                    }
                }
            }
        }

        .pop-footer {
            text-align: center;
            height: calc(100% - 40%);
            align-items: end;
            // min-height: 165px;

            .act {
                @include font-size(s);
                max-width: calc(100%);
                white-space: nowrap;
                width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
            }
            .buttons {
                flex-direction: column;
                gap: 0.5em;

                button {
                    @include font-size(s);
                }

                // .act {
                //     &.save {
                //         // background-color: $main-dark;
                //     }
                // }
            }
        }

        // &.date {
        //     // .v-picker.v-card.v-picker--date.v-picker--landscape {
        //     //     background-color: red;

        //     //     .v-picker__title.v-picker__title--landscape.primary {
        //     //         position: static;
        //     //         width: 100%;

        //     //         .v-date-picker-title {
        //     //             @include flex-direction(row);

        //     //             * {
        //     //                 @include font-size(sm);
        //     //             }

        //     //             br {
        //     //                 display: none;
        //     //             }
        //     //         }
        //     //     }

        //     //     .v-picker__body {
        //     //         position: static;
        //     //         margin-left: 0;
        //     //     }
        //     // }
        // }

        &.dateRange {
            height: 100%;

            .kind-of {
                display: inline-grid;
                // 1 column
                grid-template-columns: 1fr;
                width: 100%;
                min-height: auto;
                min-height: 688px;
                .vfc-styles-conditional-class {
                    height: 350px;
                }
            }
            @include portrait-tablet {
                .kind-of {
                    display: grid;
                    min-height: unset;
                    grid-template-columns: minmax(auto, 50%) 1fr;

                    .vfc-styles-conditional-class {
                        height: unset;
                    }
                }
            }
            .v-picker {
                box-shadow: none;

                .v-picker__title {
                    padding: 9px 16px;
                }

                .v-picker__title__btn {
                    color: #fff !important;
                    padding: 0;
                    margin: 0;

                    > * {
                        color: inherit;
                    }
                }
            }

            .primary {
                background-color: $main !important;
                border-color: $main !important;
            }
        }
        &.sign {
            .pop-body {
                .kind-of {
                    @include flex-direction(column-reverse);
                }
                .right,
                .left {
                    width: 100%;
                }
            }

            .pop-footer {
                height: 150px;
            }
        }

        &.resource {
            @include border-radius(0);
            bottom: 0 !important;
            min-width: 100%;
            height: fit-content;
            max-height: calc(100% - 60px);
            overflow: auto;

            .pop-body {
                width: 100%;
                height: 100%;
                min-height: 100%;
            }
        }

        &.select {
            gap: 0.8em;
            .list {
                height: 360px;
            }
            .pop-footer {
                min-height: 108px;
            }
        }

        &.justify {
            gap: 1em;

            .pop-body {
                width: 100%;
                padding-top: 0px;
                padding-right: 4px;
                padding-left: 4px;

                .kind-of {
                    max-width: 100%;
                    padding: 0 !important;

                    .justify-info {
                        max-width: 100%;

                        .step {
                            margin: 0;
                            width: 100%;

                            .reasons {
                                gap: 8px;
                            }

                            .item {
                                margin: 0 !important;
                            }
                        }

                        .error {
                            max-width: 100%;

                            p {
                                color: $error;
                                padding: 0px;
                                padding-bottom: 0.4em;
                                font-weight: 400;
                                font-size: 0.9rem !important;
                                text-align: center;
                            }
                        }
                    }
                }
            }

            .pop-footer {
                min-height: 108px;
            }
        }

        &.list_audits {
            .pop-body {
                margin-top: 0px;

                .list {
                    height: 366px;
                }
            }
        }

        &.temperature {
            gap: 24px !important;

            .pop-body {
                @media (max-width: 360px) {
                    height: 100%;
                    margin-top: 0px !important;
                    padding-top: 0px !important;

                    .temperature-container {
                        gap: 16px !important;
                    }

                    .number-box {
                        display: flex;
                        gap: 8px;

                        .key {
                            width: 50px !important;
                            height: 50px !important;
                            margin: 0px !important;
                        }

                        .pin {
                            height: 50px !important;
                            padding: 0px !important;
                            font-size: 24px !important;
                        }
                    }

                    .num-pad {
                        display: grid;
                        grid-template-columns: repeat(3, 1fr);
                        width: fit-content;
                        gap: 8px;

                        .key {
                            margin: 0px !important;
                            width: 54px !important;
                            height: 54px !important;
                            font-size: 24px !important;
                        }
                    }
                }
            }
        }
    }
}

// Custom styling for delete sensor popup
.popup-container.delete-sensor-popup {
    .popup.messageNewDesing {
        gap: 48px;

        .pop-header {
            background-color: $error-dark !important;

            .title {
                p {
                    @include font-size(24px);
                }
            }
        }
        .pop-body {
            overflow: visible;
            .kind-of {
                .content {
                    width: 90%;
                    margin: 0 auto;
                    @include display-flex();
                    @include flex-direction(column);
                    @include align-items(flex-start);

                    p {
                        font-family: $text;
                        @include font-size(24px);
                        color: $color-black;
                        text-align: left;
                        font-weight: 400;
                        width: 100%;

                        &::first-line {
                            font-family: $text-bold;
                            font-weight: 700;
                        }

                        strong {
                            font-family: $text;
                            font-weight: 400;
                            line-height: normal;
                        }
                    }
                }
            }
        }
        .pop-footer {
            .buttons {
                .act.save {
                    background-color: $error-dark !important;
                    color: $color-white !important;
                }

                .act.cancel {
                    background-color: $color-neutral-300 !important;
                    color: $color-black !important;
                }
            }
        }
    }
}

.app-safe-area {
    .popup-container.portrait {
        .popup {
            bottom: calc(env(safe-area-inset-bottom) + 10px);
        }
    }
}
</style>

<style lang="scss">
/* BUILD-7486: layout del modal de recomendación. No altera otros tipos. */
.popup-container.popup-recommendation {
    align-items: center;
    justify-content: center;

    .popup.recommendation {
        width: fit-content;
        max-width: calc(100vw - 48px);
        padding: 28px 20px 16px;
        gap: 16px;
        overflow: visible;
        align-items: stretch;
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.16);

        .pop-alex {
            top: -28px;
            left: 16px;
            width: 56px;
            height: 56px;
            transform: none;
            background-image: img('alex_carita_10.svg');
            background-size: 40px;
            background-color: $color-white;
            border: 2px solid $neutro-dark;
        }

        .pop-body {
            padding: 0;
            margin: 0;
            max-height: none;
            overflow: visible;
            width: 0;
            min-width: 100%;
            align-items: stretch;
            justify-content: flex-start;

            .kind-of.recommendation-body {
                display: flex !important;
                flex-direction: column !important;
                align-items: stretch !important;
                justify-content: flex-start !important;
                width: 100%;
                min-width: 0;
                height: auto;
                gap: 16px;
            }
        }

        .recommendation-copy {
            display: block;
            margin: 0;
            padding: 0;
            width: 100%;
            min-width: 0;
            background: transparent;
            color: $color-black;
            font-family: $text;
            font-size: 16px;
            line-height: 1.4;
            text-align: left;

            b {
                font-family: $text-bold;
                font-weight: 700;
            }
        }

        .recommendation-products {
            list-style: none;
            margin: 0;
            padding: 0;
            display: flex;
            flex-direction: column;
            gap: 8px;
            width: 100%;
        }

        .recommendation-product {
            display: flex;
            align-items: center;
            gap: 12px;
            width: 100%;
            min-width: 0;
            padding: 10px 12px;
            border: 1px solid $neutro-dark;
            border-radius: 4px;
            background: $color-white;
            box-sizing: border-box;
        }

        .recommendation-product-image,
        .recommendation-product-fallback {
            flex-shrink: 0;
            width: 32px;
            height: 32px;
            border-radius: 4px;
            object-fit: cover;
        }

        .recommendation-product-fallback {
            background-color: $neutro;
            background-image: img('package_black.svg');
            background-repeat: no-repeat;
            background-position: center;
            background-size: 16px;
        }

        .recommendation-product-name {
            flex: 1 1 auto;
            min-width: 0;
            font-family: $text-bold;
            font-size: 14px;
            line-height: 1.3;
            color: $color-black;
            text-transform: uppercase;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .pop-footer {
            min-height: 0;
            margin: 0;
            padding: 0;
            overflow: visible;
            width: max-content;
            max-width: none;
            align-items: stretch;
            justify-content: flex-start;

            .buttons {
                width: max-content;
                flex-wrap: nowrap;
                align-items: stretch;
                justify-content: flex-start;
                gap: 8px;

                button {
                    flex: 0 0 auto;
                    width: auto !important;
                    min-width: max-content;
                    margin: 0;
                    padding: 10px 16px;
                    overflow: visible !important;
                    text-overflow: clip;
                    white-space: nowrap;
                    line-height: 1.2;
                    text-align: center;
                    background-color: $color-neutral-300h;
                    color: $main;
                    border: none;

                    &.save {
                        background-color: $main;
                        color: $color-white;
                    }
                }
            }
        }
    }

    &.portrait {
        align-items: center !important;

        .popup.recommendation {
            width: calc(100% - 32px);
            max-width: 420px;
            margin: 0;
            bottom: auto !important;

            .pop-body {
                width: 100%;
                min-width: 0;
            }

            .pop-footer {
                width: 100%;

                .buttons {
                    width: 100%;
                    flex-direction: column;
                    flex-wrap: wrap;
                    gap: 8px;

                    button {
                        width: 100% !important;
                        min-width: 0;
                        flex: 0 0 auto;
                        height: 44px;
                        white-space: nowrap;
                    }
                }
            }
        }
    }
}

.popup-container.email-alert {
    .popup {
        .pop-body {
            min-width: 0;
            overflow-x: hidden;
            overflow-y: auto;

            .kind-of {
                min-width: 0;
                max-width: 100%;

                .message.emailAlert {
                    min-width: 0;
                    max-width: 100%;
                    box-sizing: border-box;
                    white-space: normal;
                    overflow-wrap: break-word;
                    word-break: normal;

                    .email-alert-list {
                        white-space: normal;
                        overflow-wrap: break-word;
                    }
                }
            }
        }
    }
}

.popup-container.popup-landscape-text {
    background-color: transparent;
    align-items: flex-end;
    justify-content: flex-start;
    pointer-events: auto;

    .popup.textInputLandscape {
        pointer-events: auto;
        width: 100%;
        height: calc(100% - 50px);
        max-height: calc(100% - 50px);
        max-width: 100%;
        margin: 0;
        padding: 0;
        border-radius: 0;
        background-color: #fff;
        box-shadow: none;
        flex-grow: 0;
        gap: 0;
        display: flex;
        flex-direction: column;

        .pop-header.landscape-text-header {
            flex: 0 0 auto;
            padding: 10px 16px;
            border-bottom: 1px solid #e8e8e8;
            background-color: #fff;
            position: fixed !important;
            top: 0 !important;
            left: 0 !important;
            margin-top: 0 !important;
            background-color: $color-primary-700;
            
            .title {
                margin: 0;
                font-size: 14px;
                font-weight: 600;
                line-height: 1.3;
                color: #333;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                color: $color-white;
            }
        }

        .pop-body {
            padding: 0;
            flex: 1 1 auto;
            min-height: 0;
            height: auto !important;
            width: 100%;
            max-height: none;
            overflow: hidden !important;
            bottom: 0 !important;
        }

        .kind-of.text-input-landscape {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: stretch;
        }

        .landscape-text-form {
            position: relative;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: stretch;
            margin: 0;
        }

        .landscape-text-input {
            width: 100%;
            height: 100%;
            border: none;
            outline: none;
            resize: none;
            padding: 12px 88px 12px 16px;
            font-size: 16px;
            line-height: 1.4;
            background: transparent;
            box-sizing: border-box;
        }

        .landscape-text-done {
            position: absolute;
            right: 12px;
            top: 50%;
            transform: translateY(-50%);
            padding: 8px 16px;
            border: none;
            border-radius: 20px;
            background-color: #e8e8e8;
            color: #333;
            font-size: 14px;
            cursor: pointer;
        }
    }
}

.popup.phuProduct {
    max-width: 700px;
    padding: 48px 40px 40px;
    gap: 24px;
    border: 1px solid $neutro-dark;

    .pop-body {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        padding: 0;
        overflow: auto;
    }

    .kind-of.phu-product {
        @include display-flex();
        @include flex-direction(column);
        @include align-items(stretch);
        @include justify-content(flex-start);
        width: 100%;
        height: auto;
        gap: 24px;
    }

    .phu-product__title {
        margin: 0;
        font-family: $text-bold;
        @include font-size(m);
        color: $neutro-s80;
    }

    .phu-product__search {
        @include display-flex();
        @include align-items(center);
        box-sizing: border-box;
        gap: 8px;
        height: 44px;
        padding: 8px;
        border: 1px solid $neutro-dark;
        border-radius: 4px;
        color: $neutro-s50;

        input {
            width: 100%;
            border: none;
            background: transparent;
            font-family: $text;
            @include font-size(sm);
            color: $neutro-s80;

            &::placeholder {
                color: $neutro-s50;
            }
        }
    }

    .phu-product__grid {
        display: grid;
        grid-template-columns: repeat(3, minmax(0, 1fr));
        gap: 12px;
        width: 100%;
    }

    .phu-product__card {
        @include display-flex();
        @include flex-direction(column);
        @include align-items(center);
        @include justify-content(center);
        gap: 8px;
        width: 100%;
        min-width: 0;
        padding: 8px;
        border: 1px solid $neutro-dark;
        border-radius: 8px;
        background-color: $color-white;
        font-family: $text-bold;
        @include font-size(sm);
        color: $neutro-s80;
        cursor: pointer;

        &.is-selected {
            border: 2px solid $main-dark;
            background-color: $main-t90;
        }

        &.is-disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    }

    .phu-product__disabled {
        width: 100%;
        font-family: $text;
        @include font-size(xs);
        text-align: center;
        color: $error;
    }

    .phu-product__image {
        width: 36px;
        height: 36px;
        object-fit: contain;
    }

    .phu-product__name {
        width: 100%;
        text-align: center;
        @include text-ellipsis();
    }

    .pop-footer {
        margin: 0;
        padding: 16px 0 0;
        border-top: 1px solid $neutro-t30;

        .buttons {
            @include display-flex();
            @include align-items(center);
            width: 100%;
            gap: 16px;

            button {
                flex: 1 1 0;
                width: auto;
                height: 44px;
                min-height: 44px;
                @include font-size(ml);
                line-height: 18px;
            }

            button:disabled {
                opacity: 0.4;
                cursor: not-allowed;
            }

            button.save {
                background-color: $main;
                color: $color-white;
            }

            button.cancel {
                background-color: $main-t90;
                color: $main-dark;
            }
        }
    }
}

.popup-container .popup.phuNoEquipment {
    box-sizing: border-box;
    width: 771px;
    max-width: calc(100vw - 32px);
    height: auto;
    flex: 0 0 auto;
    align-self: center;
    margin: 0;
    bottom: auto;
    padding: 48px 40px 40px;
    gap: 48px;
    border: 1px solid $neutro-dark;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.04), 0 4px 4px rgba(0, 0, 0, 0.06);
    overflow: visible;
    align-items: stretch;
    justify-content: flex-start;

    .pop-alex-lottie {
        top: -41px;
        left: 39px;
        box-sizing: border-box;
        width: 80px;
        height: 80px;
        border-width: 2px;
        border-color: $neutro-dark;
    }

    .pop-body {
        display: block;
        width: 100%;
        min-width: 0;
        max-width: 100%;
        height: auto;
        max-height: none;
        margin: 0;
        padding: 0;
        overflow: visible;
    }

    .pop-body .kind-of.phu-no-equipment {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        justify-content: flex-start;
        gap: 16px;
        width: 100%;
        min-width: 0;
        height: auto;
    }

    .phu-no-equipment__badge {
        align-self: flex-start;
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        padding: 8px;
        border-radius: 4px;
        background-color: $warning-t90;

        i{
            color: $warning;
        }
    }

    .phu-no-equipment__title,
    .phu-no-equipment__message {
        display: block;
        width: 100%;
        margin: 0;
        line-height: normal;
        color: $neutro-s80;
    }

    .phu-no-equipment__title {
        font-family: $text-bold;
        font-size: 1.5rem;
    }

    .phu-no-equipment__message {
        font-family: $text;
        font-size: 1.25rem;
        white-space: pre-line;
    }

    .pop-footer {
        width: 100%;
        padding: 0;
        border: none;

        .buttons {
            display: flex;
            flex-direction: row;
            align-items: center;
            width: 100%;
            gap: 16px;

            button {
                flex: 1 1 0;
                width: auto;
                min-height: 40px;
                padding: 10px 24px;
                font-family: $text-bold;
                font-size: 1.25rem;
                line-height: 18px;
            }

            button.save {
                background-color: $main-text;
                color: $color-white;
            }

            button.cancel {
                background-color: $main-t90;
                color: $main;
            }
        }
    }
}

.popup-container.phu-cook-quantity .popup.phuWaste .pop-header {
    background-color: $color-primary-500;
}

.popup-container .popup.phuWaste {
    box-sizing: border-box;
    width: 380px;
    max-width: calc(100vw - 32px);
    height: auto;
    flex: 0 0 auto;
    align-self: center;
    margin: 0;
    bottom: auto;
    padding: 0;
    gap: 0;
    border-radius: 4px;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.16);
    overflow: hidden;

    .pop-header {
        @include display-flex();
        @include align-items(center);
        @include justify-content(space-between);
        width: 100%;
        margin: 0;
        padding: 0 0 0 16px;
        border-radius: 4px 4px 0 0;
        background-color: $error-dark;
    }

    .phu-waste__title {
        margin: 0;
        font-family: $text-bold;
        font-size: 1.25rem;
        line-height: normal;
        color: $color-white;
    }

    .phu-waste__close {
        @include display-flex();
        @include align-items(center);
        @include justify-content(center);
        width: 48px;
        height: 48px;
        padding: 0;
        border: none;
        background: transparent;
        color: $color-white;
        cursor: pointer;

        i {
            color: $color-white;
        }
    }

    .pop-body {
        display: block;
        width: 100%;
        min-width: 0;
        max-width: 100%;
        height: auto;
        margin: 0;
        padding: 24px 48px;
        overflow: auto;
        background-color: $color-white;
    }

    .pop-body .kind-of.phu-waste {
        @include display-flex();
        @include flex-direction(column);
        @include align-items(center);
        gap: 8px;
        width: 100%;
        min-width: 0;
        height: auto;
        padding: 0;
    }

    .phu-waste__product {
        @include display-flex();
        @include align-items(center);
        gap: 8px;
        width: 100%;
    }

    .phu-waste__image {
        width: 48px;
        height: 48px;
        object-fit: fill;
    }

    .phu-waste__name {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        margin: 0;
        font-family: $text-bold;
        font-size: 1.5rem;
        line-height: 1.2;
        text-transform: uppercase;
        word-break: normal;
        overflow-wrap: normal;
        color: $neutro-s80;
    }

    .phu-waste__message {
        width: 100%;
        min-width: 0;
        margin: 0;
        font-family: $text;
        font-size: 1.25rem;
        line-height: 1.3;
        text-align: center;
        white-space: normal;
        overflow-wrap: break-word;
        color: $neutro-s80;
    }

    .phu-waste__keyboard {
        @include display-flex();
        @include flex-direction(column);
        @include align-items(center);
        box-sizing: border-box;
        gap: 16px;
        width: 100%;
        padding: 24px;
        background-color: $neutro-t80;
    }

    .phu-waste__keyboard .numpad-container {
        @include display-flex();
        @include flex-direction(column);
        gap: 16px;
        width: 100%;

        .num-padtop,
        .num-pad {
            display: grid;
            grid-template-columns: repeat(3, minmax(0, 1fr));
            gap: 8px;
            width: 100%;
            height: auto;
            margin: 0;
        }

        .num-pad {
            grid-auto-rows: 60px;
        }

        .key,
        .num-padtop .pin,
        .num-padtop.has-quantity .pin {
            box-sizing: border-box;
            width: 100%;
            height: 60px;
            margin: 0;
            border-radius: 4px;
            background-color: $color-white;
            box-shadow: 0 0 3px rgba(0, 0, 0, 0.02), 0 2px 2px rgba(0, 0, 0, 0.08);
        }

        .key {
            font-family: $text-bold;
            font-size: 1.375rem;
            color: $main-s40;
        }

        .key.operator {
            background-color: $main-t90;
        }

        .key.operator.disabled {
            opacity: 0.4;
            pointer-events: none;
        }

        .num-padtop .pin.new-desing {
            font-family: $text;
            font-size: 2rem;
            line-height: 60px;
            text-transform: none;
            color: $main-s20 !important;
        }

        .key.save-and-close,
        .key.save-and-close:hover {
            background-color: $color-white !important;

            i[class^='i-andy-'] {
                color: $color-success-500;
            }
        }
    }

    .phu-waste__cancel {
        width: 100%;
        min-height: 40px;
        padding: 8px;
        border: none;
        border-radius: 4px;
        background-color: $main-t90;
        font-family: $text-bold;
        font-size: 1.25rem;
        line-height: 18px;
        color: $main-dark;
        cursor: pointer;
    }
}

.popup.phuAssign {
    max-width: 760px;
    padding: 48px 40px 40px;
    gap: 24px;
    border: 1px solid $neutro-dark;

    .pop-body {
        width: 100%;
        min-width: 100%;
        max-width: 100%;
        padding: 0;
        overflow: auto;
    }

    .kind-of.phu-assign {
        width: 100%;
        height: auto;
    }

    .pop-footer {
        padding: 16px 0 0;
        border-top: 1px solid $neutro-t30;

        .buttons {
            @include display-flex();
            @include align-items(center);
            width: 100%;
            gap: 16px;

            button {
                flex: 1;
                width: auto;
                min-height: 40px;
                @include font-size(ml);
                line-height: 18px;
            }

            button.save {
                background-color: $main;
                color: $color-white;
            }

            button.save:disabled {
                opacity: 0.45;
                cursor: default;
            }

            button.cancel {
                background-color: $main-t90;
                color: $main-dark;
            }
        }
    }
}
</style>
